import {
  topicTeacherImgs,
  topicFireEngineerImgs,
  topicLicensedPharmacistImgs,
  selfStudyImgs,
  topicJuniorAccountantImgs,
} from '../../images/topicImg';

// 教师资格证total
export const SummaryTeacherData = [
  { title: '精品课程', id: 1, content: '1366', icon: '分钟', right_icon: '/' },
  { title: '章节练习', id: 2, content: '427', icon: '题', right_icon: '/' },
  { title: '课程数量', id: 3, content: '53', icon: '个', right_icon: '/' },
  { title: '模考套题', id: 4, content: '18', icon: '套', right_icon: '/' },
  { title: '答疑周期', id: 5, content: '24', icon: '小时', right_icon: '/' },
  { title: '教学服务', id: 6, content: '720', icon: '天' },
];

// 教师资格证 - 课程体系
export const CurriculumTabsList = {
  title: '课程体系',
  subtitle: '选对适合课程， 让备考事半功倍',
  name: 'curriculum',
  url: topicTeacherImgs.title_kecheng,
  list: [
    {
      title: '幼儿',
      id: 1,
      active: true,
      itemData: [
        {
          title: '通关班',
          subTitle: '（笔试+面试）',
          price: 420,
          id: 1,
          SuitableData: [
            { content: '零基础或新参考生', id: 1 },
            { content: '自制力差需要督促', id: 2 },
            { content: '追求课程性价比的考生', id: 3 },
          ], //适合人群
          CourseContentData: [
            { content: '幼儿综合素质 + 幼儿保教知识能力', id: 1 },
            { content: '幼儿面试 + 普通话测试', id: 2 },
          ], //课程内容
          ServiceAssuranceData: [
            {
              title: '班级保障',
              id: 1,
              list: [
                { content: '报名日起2年内有效', id: 1 },
                { content: '免费重学一次（考试未过可享，每年免费重学新版课程）', id: 2 },
                { content: '课程有效期内笔试未过，退课程差价100元', id: 3 },
                { content: '如因个人原因缺考，则不退费', id: 4 },
              ],
            },
            {
              title: '服务承诺',
              id: 2,
              url: topicTeacherImgs.kecheng_tuihuan,
            },
          ], //服务保障
          IncludeClassData: [
            {
              title: '基础阶段',
              list: [{ content: '教材精讲班', icon: '', id: 1 }],
              isFree: false,
              id: 1,
            },
            {
              title: '强化阶段',
              list: [{ content: '冲刺押题班', icon: '', id: 1 }],
              isFree: false,
              id: 2,
            },
            {
              title: '冲刺阶段',
              list: [
                { content: '历年真题班', icon: '', id: 1 },
                { content: '模拟试题班', icon: '', id: 2 },
              ],
              isFree: false,
              id: 3,
            },
            {
              title: '面试阶段',
              list: [{ content: '幼儿面试班', icon: '', id: 1 }],
              isFree: false,
              id: 4,
            },
            {
              title: '附赠',
              list: [{ content: '普通话测试', icon: '', id: 1 }],
              isFree: true,
              id: 5,
            },
          ], //包含班级
          CourseBenefitsData: [
            {
              icon: topicTeacherImgs.kecheng_xiang,
              id: 1,
              list: [
                { content: '超值优惠最低低至三折', id: 1 },
                { content: '老师24小时答疑', id: 2 },
                { content: '考试重点消息短信通知', id: 3 },
                { content: '考生交流学习群', id: 4 },
              ],
            },
            {
              icon: topicTeacherImgs.kecheng_song,
              id: 2,
              list: [
                { content: '权威收费题库', id: 1 },
                { content: '考前小宝典', id: 2 },
                { content: '全科黄金考点', id: 3 },
                { content: '量身定制专属学习计划', id: 4 },
                { content: '精制版课程讲义', id: 5 },
              ],
            },
          ], //课程优势
        },
        {
          title: '高端取证班',
          subTitle: '',
          price: 320,
          id: 2,
          SuitableData: [
            { content: '基础相对薄弱的新老考生', id: 1 },
            { content: '全面突破，需要系统的辅导', id: 2 },
            { content: '非师范专业毕业，学习能力差', id: 3 },
          ], //适合人群
          CourseContentData: [
            { content: '幼儿综合素质 + 幼儿保教知识能力', id: 1 },
            { content: '幼儿面试', id: 2 },
          ], //课程内容
          ServiceAssuranceData: [
            {
              title: '班级保障',
              id: 1,
              list: [
                { content: '报名日起2年内有效', id: 1 },
                { content: '免费重学一次（考试未过可享，每年免费重学新版课程）', id: 2 },
              ],
            },
            { title: '服务承诺', id: 2, url: topicTeacherImgs.kecheng_tuihuan },
          ], //服务保障
          IncludeClassData: [
            {
              title: '基础阶段',
              list: [{ content: '教材精讲班', icon: '', id: 1 }],
              isFree: false,
              id: 1,
            },
            {
              title: '强化阶段',
              list: [{ content: '冲刺押题班', icon: '', id: 1 }],
              isFree: false,
              id: 2,
            },
            {
              title: '冲刺阶段',
              list: [
                { content: '历年真题班', icon: '', id: 1 },
                { content: '模拟试题班', icon: '', id: 2 },
              ],
              isFree: false,
              id: 3,
            },
            {
              title: '附赠',
              list: [{ content: '普通话测试', icon: '', id: 1 }],
              isFree: true,
              id: 5,
            },
          ], //包含班级
          CourseBenefitsData: [
            {
              icon: topicTeacherImgs.kecheng_xiang,
              id: 1,
              list: [
                { content: '超值优惠最低低至三折', id: 1 },
                { content: '老师24小时答疑', id: 2 },
                { content: '考试重点消息短信通知', id: 3 },
                { content: '考生交流学习群', id: 4 },
              ],
            },
            {
              icon: topicTeacherImgs.kecheng_song,
              id: 2,
              list: [
                { content: '权威收费题库', id: 1 },
                { content: '考前小宝典', id: 2 },
                { content: '全科黄金考点', id: 3 },
                { content: '量身定制专属学习计划', id: 4 },
                { content: '精制版课程讲义', id: 5 },
              ],
            },
          ], //课程优势
        },
        {
          title: '教材精讲班',
          subTitle: '',
          price: 200,
          id: 3,
          SuitableData: [
            { content: '有考试经验的考生', id: 1 },
            { content: '从事过助教等工作的考生', id: 2 },
            { content: '学习自律性强的考生', id: 3 },
          ], //适合人群
          CourseContentData: [{ content: '幼儿综合素质 + 幼儿保教知识能力', id: 1 }], //课程内容
          ServiceAssuranceData: [
            {
              title: '班级保障',
              id: 1,
              list: [{ content: '报名日起1年内有效', id: 1 }],
            },
            { title: '服务承诺', id: 2, url: topicTeacherImgs.kecheng_tuihuan },
          ], //服务保障
          IncludeClassData: [
            {
              title: '基础阶段',
              list: [{ content: '教材精讲班', icon: '', id: 1 }],
              isFree: false,
              id: 1,
            },
          ], //包含班级
          CourseBenefitsData: [
            {
              icon: topicTeacherImgs.kecheng_xiang,
              id: 1,
              list: [
                { content: '老师24小时答疑', id: 2 },
                { content: '考生交流学习群', id: 4 },
              ],
            },
            {
              icon: topicTeacherImgs.kecheng_song,
              id: 2,
              list: [{ content: '精制版课程讲义', id: 5 }],
            },
          ], //课程优势
        },
      ],
    },
    {
      title: '小学',
      id: 2,
      active: false,
      itemData: [
        {
          title: '通关班',
          subTitle: '（笔试+面试）',
          price: 420,
          id: 1,
          SuitableData: [
            { content: '零基础或新参考生', id: 1 },
            { content: '自制力差需要督促', id: 2 },
            { content: '追求课程性价比的考生', id: 3 },
          ], //适合人群
          CourseContentData: [
            { content: '小学综合素质 + 小学教育教学与知识能力', id: 1 },
            { content: '小学面试 + 普通话测试', id: 2 },
          ], //课程内容
          ServiceAssuranceData: [
            {
              title: '班级保障',
              id: 1,
              list: [
                { content: '报名日起2年内有效', id: 1 },
                { content: '免费重学一次（考试未过可享，每年免费重学新版课程）', id: 2 },
                { content: '课程有效期内笔试未过，退课程差价100元', id: 3 },
                { content: '如因个人原因缺考，则不退费', id: 4 },
              ],
            },
            {
              title: '服务承诺',
              id: 2,
              url: topicTeacherImgs.kecheng_tuihuan,
            },
          ], //服务保障
          IncludeClassData: [
            {
              title: '基础阶段',
              list: [{ content: '教材精讲班', icon: '', id: 1 }],
              isFree: false,
              id: 1,
            },
            {
              title: '强化阶段',
              list: [{ content: '冲刺押题班', icon: '', id: 1 }],
              isFree: false,
              id: 2,
            },
            {
              title: '冲刺阶段',
              list: [
                { content: '历年真题班', icon: '', id: 1 },
                { content: '模拟试题班', icon: '', id: 2 },
              ],
              isFree: false,
              id: 3,
            },
            {
              title: '面试阶段',
              list: [{ content: '小学面试班', icon: '', id: 1 }],
              isFree: false,
              id: 4,
            },
            {
              title: '附赠',
              list: [{ content: '普通话测试', icon: '', id: 1 }],
              isFree: true,
              id: 5,
            },
          ], //包含班级
          CourseBenefitsData: [
            {
              icon: topicTeacherImgs.kecheng_xiang,
              id: 1,
              list: [
                { content: '超值优惠最低低至三折', id: 1 },
                { content: '老师24小时答疑', id: 2 },
                { content: '考试重点消息短信通知', id: 3 },
                { content: '考生交流学习群', id: 4 },
              ],
            },
            {
              icon: topicTeacherImgs.kecheng_song,
              id: 2,
              list: [
                { content: '权威收费题库', id: 1 },
                { content: '考前小宝典', id: 2 },
                { content: '全科黄金考点', id: 3 },
                { content: '量身定制专属学习计划', id: 4 },
                { content: '精制版课程讲义', id: 5 },
              ],
            },
          ], //课程优势
        },
        {
          title: '高端取证班',
          subTitle: '',
          price: 320,
          id: 2,
          SuitableData: [
            { content: '基础相对薄弱的新老考生', id: 1 },
            { content: '全面突破，需要系统的辅导', id: 2 },
            { content: '非师范专业毕业，学习能力差', id: 3 },
          ], //适合人群
          CourseContentData: [
            { content: '小学综合素质 + 小学教育教学与知识能力', id: 1 },
            { content: '小学面试', id: 2 },
          ], //课程内容
          ServiceAssuranceData: [
            {
              title: '班级保障',
              id: 1,
              list: [
                { content: '报名日起2年内有效', id: 1 },
                { content: '免费重学一次（考试未过可享，每年免费重学新版课程）', id: 2 },
              ],
            },
            { title: '服务承诺', id: 2, url: topicTeacherImgs.kecheng_tuihuan },
          ], //服务保障
          IncludeClassData: [
            {
              title: '基础阶段',
              list: [{ content: '教材精讲班', icon: '', id: 1 }],
              isFree: false,
              id: 1,
            },
            {
              title: '强化阶段',
              list: [{ content: '冲刺押题班', icon: '', id: 1 }],
              isFree: false,
              id: 2,
            },
            {
              title: '冲刺阶段',
              list: [
                { content: '历年真题班', icon: '', id: 1 },
                { content: '模拟试题班', icon: '', id: 2 },
              ],
              isFree: false,
              id: 3,
            },
            {
              title: '附赠',
              list: [{ content: '普通话测试', icon: '', id: 1 }],
              isFree: true,
              id: 5,
            },
          ], //包含班级
          CourseBenefitsData: [
            {
              icon: topicTeacherImgs.kecheng_xiang,
              id: 1,
              list: [
                { content: '超值优惠最低低至三折', id: 1 },
                { content: '老师24小时答疑', id: 2 },
                { content: '考试重点消息短信通知', id: 3 },
                { content: '考生交流学习群', id: 4 },
              ],
            },
            {
              icon: topicTeacherImgs.kecheng_song,
              id: 2,
              list: [
                { content: '权威收费题库', id: 1 },
                { content: '考前小宝典', id: 2 },
                { content: '全科黄金考点', id: 3 },
                { content: '量身定制专属学习计划', id: 4 },
                { content: '精制版课程讲义', id: 5 },
              ],
            },
          ], //课程优势
        },
        {
          title: '教材精讲班',
          subTitle: '',
          price: 200,
          id: 3,
          SuitableData: [
            { content: '有考试经验的考生', id: 1 },
            { content: '从事过助教等工作的考生', id: 2 },
            { content: '学习自律性强的考生', id: 3 },
          ], //适合人群
          CourseContentData: [{ content: '小学综合素质 + 小学教育教学与知识能力', id: 1 }], //课程内容
          ServiceAssuranceData: [
            {
              title: '班级保障',
              id: 1,
              list: [{ content: '报名日起1年内有效', id: 1 }],
            },
            { title: '服务承诺', id: 2, url: topicTeacherImgs.kecheng_tuihuan },
          ], //服务保障
          IncludeClassData: [
            {
              title: '基础阶段',
              list: [{ content: '教材精讲班', icon: '', id: 1 }],
              isFree: false,
              id: 1,
            },
          ], //包含班级
          CourseBenefitsData: [
            {
              icon: topicTeacherImgs.kecheng_xiang,
              id: 1,
              list: [
                { content: '老师24小时答疑', id: 2 },
                { content: '考生交流学习群', id: 4 },
              ],
            },
            {
              icon: topicTeacherImgs.kecheng_song,
              id: 2,
              list: [{ content: '精制版课程讲义', id: 5 }],
            },
          ], //课程优势
        },
      ],
    },
    {
      title: '中学',
      id: 3,
      active: false,
      itemData: [
        {
          title: '通关班',
          subTitle: '（笔试+面试）',
          price: 580,
          id: 1,
          SuitableData: [
            { content: '零基础或新参考生', id: 1 },
            { content: '自制力差需要督促', id: 2 },
            { content: '追求课程性价比的考生', id: 3 },
          ], //适合人群
          CourseContentData: [
            { content: '中学综合素质 + 中学教育教学与知识能力', id: 1 },
            { content: '专业知识与教学能力（自选一科）', id: 2 },
            { content: '中学面试 + 普通话测试', id: 3 },
          ], //课程内容
          ServiceAssuranceData: [
            {
              title: '班级保障',
              id: 1,
              list: [
                { content: '报名日起2年内有效', id: 1 },
                { content: '免费重学一次（考试未过可享，每年免费重学新版课程）', id: 2 },
                { content: '课程有效期内笔试未过，退课程差价100元', id: 3 },
                { content: '如因个人原因缺考，则不退费', id: 4 },
              ],
            },
            {
              title: '服务承诺',
              id: 2,
              url: topicTeacherImgs.kecheng_tuihuan,
            },
          ], //服务保障
          IncludeClassData: [
            {
              title: '基础阶段',
              list: [{ content: '教材精讲班', icon: '', id: 1 }],
              isFree: false,
              id: 1,
            },
            {
              title: '强化阶段',
              list: [{ content: '冲刺押题班', icon: '', id: 1 }],
              isFree: false,
              id: 2,
            },
            {
              title: '冲刺阶段',
              list: [
                { content: '历年真题班', icon: '', id: 1 },
                { content: '模拟试题班', icon: '', id: 2 },
              ],
              isFree: false,
              id: 3,
            },
            {
              title: '面试阶段',
              list: [{ content: '中学面试班', icon: '', id: 1 }],
              isFree: false,
              id: 4,
            },
            {
              title: '附赠',
              list: [{ content: '普通话测试', icon: '', id: 1 }],
              isFree: true,
              id: 5,
            },
          ], //包含班级
          CourseBenefitsData: [
            {
              icon: topicTeacherImgs.kecheng_xiang,
              id: 1,
              list: [
                { content: '超值优惠最低低至三折', id: 1 },
                { content: '老师24小时答疑', id: 2 },
                { content: '考试重点消息短信通知', id: 3 },
                { content: '考生交流学习群', id: 4 },
              ],
            },
            {
              icon: topicTeacherImgs.kecheng_song,
              id: 2,
              list: [
                { content: '权威收费题库', id: 1 },
                { content: '考前小宝典', id: 2 },
                { content: '全科黄金考点', id: 3 },
                { content: '量身定制专属学习计划', id: 4 },
                { content: '精制版课程讲义', id: 5 },
              ],
            },
          ], //课程优势
        },
        {
          title: '高端取证班',
          subTitle: '',
          price: 499,
          id: 2,
          SuitableData: [
            { content: '基础相对薄弱的新老考生', id: 1 },
            { content: '全面突破，需要系统的辅导', id: 2 },
            { content: '非师范专业毕业，学习能力差', id: 3 },
          ], //适合人群
          CourseContentData: [
            { content: '中学综合素质 + 中学教育教学与知识能力', id: 1 },
            { content: '专业知识与教学能力（自选一科）', id: 2 },
            { content: '普通话测试', id: 3 },
          ], //课程内容
          ServiceAssuranceData: [
            {
              title: '班级保障',
              id: 1,
              list: [
                { content: '报名日起2年内有效', id: 1 },
                { content: '免费重学一次（考试未过可享，每年免费重学新版课程）', id: 2 },
              ],
            },
            { title: '服务承诺', id: 2, url: topicTeacherImgs.kecheng_tuihuan },
          ], //服务保障
          IncludeClassData: [
            {
              title: '基础阶段',
              list: [{ content: '教材精讲班', icon: '', id: 1 }],
              isFree: false,
              id: 1,
            },
            {
              title: '强化阶段',
              list: [{ content: '冲刺押题班', icon: '', id: 1 }],
              isFree: false,
              id: 2,
            },
            {
              title: '冲刺阶段',
              list: [
                { content: '历年真题班', icon: '', id: 1 },
                { content: '模拟试题班', icon: '', id: 2 },
              ],
              isFree: false,
              id: 3,
            },
            {
              title: '附赠',
              list: [{ content: '普通话测试', icon: '', id: 1 }],
              isFree: true,
              id: 5,
            },
          ], //包含班级
          CourseBenefitsData: [
            {
              icon: topicTeacherImgs.kecheng_xiang,
              id: 1,
              list: [
                { content: '超值优惠最低低至三折', id: 1 },
                { content: '老师24小时答疑', id: 2 },
                { content: '考试重点消息短信通知', id: 3 },
                { content: '考生交流学习群', id: 4 },
              ],
            },
            {
              icon: topicTeacherImgs.kecheng_song,
              id: 2,
              list: [
                { content: '权威收费题库', id: 1 },
                { content: '考前小宝典', id: 2 },
                { content: '全科黄金考点', id: 3 },
                { content: '量身定制专属学习计划', id: 4 },
                { content: '精制版课程讲义', id: 5 },
              ],
            },
          ], //课程优势
        },
        {
          title: '教材精讲班',
          subTitle: '',
          price: 380,
          id: 3,
          SuitableData: [
            { content: '有考试经验的考生', id: 1 },
            { content: '从事过助教等工作的考生', id: 2 },
            { content: '学习自律性强的考生', id: 3 },
          ], //适合人群
          CourseContentData: [
            { content: '中学综合素质 + 中学教育教学与知识能力', id: 1 },
            { content: '专业知识与教学能力（自选一科）', id: 2 },
          ], //课程内容
          ServiceAssuranceData: [
            {
              title: '班级保障',
              id: 1,
              list: [{ content: '报名日起1年内有效', id: 1 }],
            },
            { title: '服务承诺', id: 2, url: topicTeacherImgs.kecheng_tuihuan },
          ], //服务保障
          IncludeClassData: [
            {
              title: '基础阶段',
              list: [{ content: '教材精讲班', icon: '', id: 1 }],
              isFree: false,
              id: 1,
            },
          ], //包含班级
          CourseBenefitsData: [
            {
              icon: topicTeacherImgs.kecheng_xiang,
              id: 1,
              list: [
                { content: '老师24小时答疑', id: 2 },
                { content: '考生交流学习群', id: 4 },
              ],
            },
            {
              icon: topicTeacherImgs.kecheng_song,
              id: 2,
              list: [{ content: '精制版课程讲义', id: 5 }],
            },
          ], //课程优势
        },
      ],
    },
  ],
};

//教师资格证 - 单选班级
export const ClassTabsList = {
  title: '单选班级',
  subtitle: '2020教师资格证单科辅导课程，可单独购买',
  name: 'class',
  url: topicTeacherImgs.title_kecheng,
  list: [
    {
      title: '幼儿',
      id: 1,
      active: true,
      itemsData: [
        {
          title: '教材精讲班',
          id: 1,
          active: true,
          classInfo: '梳理备考要点体系，搭建知识框架，扫除知识盲点',
          assortService: [
            { title: '权威题库', id: 1 },
            { title: '移动课堂', id: 2 },
            { title: '课程讲义', id: 3 },
            { title: '视频下载', id: 4 },
          ],
          validity: '12个月',
          courseList: [
            {
              id: 1,
              title: '《幼儿综合素质》教材精讲班',
              teacher: '苏云尚',
              classHour: '25h',
              price: '￥100',
              experience: '免费试听',
              icon: topicTeacherImgs.kecheng_shiting,
            },
            {
              id: 2,
              title: '《幼儿保教与知识能力》教材精讲班',
              teacher: '孙琳',
              classHour: '25h',
              price: '￥100',
              experience: '免费试听',
              icon: topicTeacherImgs.kecheng_shiting,
            },
          ],
        },
        {
          title: '模拟试题班',
          id: 2,
          active: false,
          classInfo: '解题能力强化，模拟试卷检测，查漏补缺，加深理论理解，提高答题速度及正确率',
          assortService: [
            { title: '权威题库', id: 1 },
            { title: '移动课堂', id: 2 },
            { title: '课程讲义', id: 3 },
            { title: '视频下载', id: 4 },
          ],
          validity: '12个月',
          courseList: [
            {
              id: 1,
              title: '《幼儿综合素质》模拟试题班',
              teacher: '陈龙',
              classHour: '6h',
              price: '￥100',
              experience: '免费试听',
              icon: topicTeacherImgs.kecheng_shiting,
            },
            {
              id: 2,
              title: '《幼儿保教与知识能力》模拟试题班',
              teacher: '雷智慧',
              classHour: '6h',
              price: '￥100',
              experience: '免费试听',
              icon: topicTeacherImgs.kecheng_shiting,
            },
          ],
        },
        {
          title: '冲刺押题班',
          id: 3,
          active: false,
          classInfo: '提炼常考必考点，分类别讲授，点对点突破',
          assortService: [
            { title: '权威题库', id: 1 },
            { title: '移动课堂', id: 2 },
            { title: '课程讲义', id: 3 },
            { title: '视频下载', id: 4 },
          ],
          validity: '12个月',
          courseList: [
            {
              id: 1,
              title: '《幼儿综合素质》冲刺押题班',
              teacher: '苏云尚',
              classHour: '3h',
              price: '￥100',
              experience: '免费试听',
              icon: topicTeacherImgs.kecheng_shiting,
            },
            {
              id: 2,
              title: '《幼儿保教与知识能力》冲刺押题班',
              teacher: '孙琳',
              classHour: '3h',
              price: '￥100',
              experience: '免费试听',
              icon: topicTeacherImgs.kecheng_shiting,
            },
          ],
        },
        {
          title: '历年真题班',
          id: 4,
          active: false,
          classInfo: '结合近三年真题全解，巩固考点，总结答题“套路”应万变',
          assortService: [
            { title: '权威题库', id: 1 },
            { title: '移动课堂', id: 2 },
            { title: '课程讲义', id: 3 },
            { title: '视频下载', id: 4 },
          ],
          validity: '12个月',
          courseList: [
            {
              id: 1,
              title: '《幼儿综合素质》历年真题班',
              teacher: '苏云尚',
              classHour: '4h',
              price: '￥100',
              experience: '免费试听',
              icon: topicTeacherImgs.kecheng_shiting,
            },
            {
              id: 2,
              title: '《幼儿保教与知识能力》历年真题班',
              teacher: '孙琳',
              classHour: '4h',
              price: '￥100',
              experience: '免费试听',
              icon: topicTeacherImgs.kecheng_shiting,
            },
          ],
        },
        {
          title: '普通话测试',
          id: 5,
          active: false,
          classInfo: '考试流程题型及技巧分析，声韵母发音技巧指导',
          assortService: [
            { title: '权威题库', id: 1 },
            { title: '移动课堂', id: 2 },
            { title: '课程讲义', id: 3 },
            { title: '视频下载', id: 4 },
          ],
          validity: '12个月',
          courseList: [
            {
              id: 1,
              title: '《普通话测试》精讲班',
              teacher: '孙琳',
              classHour: '3h',
              price: '￥100',
              experience: '免费试听',
              icon: topicTeacherImgs.kecheng_shiting,
            },
          ],
        },
        {
          title: '面试班',
          id: 6,
          active: false,
          classInfo: '结合面试考情，全面讲解结构化、试讲、说课和答辩各模块考核内容',
          assortService: [
            { title: '权威题库', id: 1 },
            { title: '移动课堂', id: 2 },
            { title: '课程讲义', id: 3 },
            { title: '视频下载', id: 4 },
          ],
          validity: '12个月',
          courseList: [
            {
              id: 1,
              title: '《幼儿园面试》面试概述（一）',
              teacher: '孙琳',
              classHour: '10h',
              price: '￥300',
              experience: '免费试听',
              icon: topicTeacherImgs.kecheng_shiting,
            },
          ],
        },
      ],
    },
    {
      title: '小学',
      id: 2,
      active: false,
      itemsData: [
        {
          title: '教材精讲班',
          id: 1,
          active: true,
          classInfo: '梳理备考要点体系，搭建知识框架，扫除知识盲点',
          assortService: [
            { title: '权威题库', id: 1 },
            { title: '移动课堂', id: 2 },
            { title: '课程讲义', id: 3 },
            { title: '视频下载', id: 4 },
          ],
          validity: '12个月',
          courseList: [
            {
              id: 1,
              title: '《小学综合素质》教材精讲班',
              teacher: '陈龙',
              classHour: '25h',
              price: '￥100',
              experience: '免费试听',
              icon: topicTeacherImgs.kecheng_shiting,
            },
            {
              id: 2,
              title: '《小学教育教学与知识能力》教材精讲班',
              teacher: '雷智慧',
              classHour: '25h',
              price: '￥100',
              experience: '免费试听',
              icon: topicTeacherImgs.kecheng_shiting,
            },
          ],
        },
        {
          title: '模拟试题班',
          id: 2,
          active: false,
          classInfo: '解题能力强化，模拟试卷检测，查漏补缺，加深理论理解，提高答题速度及正确率',
          assortService: [
            { title: '权威题库', id: 1 },
            { title: '移动课堂', id: 2 },
            { title: '课程讲义', id: 3 },
            { title: '视频下载', id: 4 },
          ],
          validity: '12个月',
          courseList: [
            {
              id: 1,
              title: '《小学综合素质》模拟试题班',
              teacher: '陈龙',
              classHour: '6h',
              price: '￥100',
              experience: '免费试听',
              icon: topicTeacherImgs.kecheng_shiting,
            },
            {
              id: 2,
              title: '《小学教育教学与知识能力》模拟试题班',
              teacher: '雷智慧',
              classHour: '6h',
              price: '￥100',
              experience: '免费试听',
              icon: topicTeacherImgs.kecheng_shiting,
            },
          ],
        },
        {
          title: '冲刺押题班',
          id: 3,
          active: false,
          classInfo: '提炼常考必考点，分类别讲授，点对点突破',
          assortService: [
            { title: '权威题库', id: 1 },
            { title: '移动课堂', id: 2 },
            { title: '课程讲义', id: 3 },
            { title: '视频下载', id: 4 },
          ],
          validity: '12个月',
          courseList: [
            {
              id: 1,
              title: '《小学综合素质》冲刺押题班',
              teacher: '陈龙',
              classHour: '3h',
              price: '￥100',
              experience: '免费试听',
              icon: topicTeacherImgs.kecheng_shiting,
            },
            {
              id: 2,
              title: '《小学教育教学与知识能力》冲刺押题班',
              teacher: '雷智慧',
              classHour: '3h',
              price: '￥100',
              experience: '免费试听',
              icon: topicTeacherImgs.kecheng_shiting,
            },
          ],
        },
        {
          title: '历年真题班',
          id: 4,
          active: false,
          classInfo: '结合近三年真题全解，巩固考点，总结答题“套路”应万变',
          assortService: [
            { title: '权威题库', id: 1 },
            { title: '移动课堂', id: 2 },
            { title: '课程讲义', id: 3 },
            { title: '视频下载', id: 4 },
          ],
          validity: '12个月',
          courseList: [
            {
              id: 1,
              title: '《小学综合素质》历年真题班',
              teacher: '陈龙',
              classHour: '4h',
              price: '￥100',
              experience: '免费试听',
              icon: topicTeacherImgs.kecheng_shiting,
            },
            {
              id: 2,
              title: '《小学教育教学与知识能力》历年真题班',
              teacher: '雷智慧',
              classHour: '4h',
              price: '￥100',
              experience: '免费试听',
              icon: topicTeacherImgs.kecheng_shiting,
            },
          ],
        },
        {
          title: '普通话测试',
          id: 5,
          active: false,
          classInfo: '考试流程题型及技巧分析，声韵母发音技巧指导',
          assortService: [
            { title: '权威题库', id: 1 },
            { title: '移动课堂', id: 2 },
            { title: '课程讲义', id: 3 },
            { title: '视频下载', id: 4 },
          ],
          validity: '12个月',
          courseList: [
            {
              id: 1,
              title: '《普通话测试》精讲班',
              teacher: '张凌薇',
              classHour: '3h',
              price: '￥100',
              experience: '免费试听',
              icon: topicTeacherImgs.kecheng_shiting,
            },
          ],
        },
        {
          title: '面试班',
          id: 6,
          active: false,
          classInfo: '结合面试考情，全面讲解结构化、试讲、说课和答辩各模块考核内容',
          assortService: [
            { title: '权威题库', id: 1 },
            { title: '移动课堂', id: 2 },
            { title: '课程讲义', id: 3 },
            { title: '视频下载', id: 4 },
          ],
          validity: '12个月',
          courseList: [
            {
              id: 1,
              title: '《小学面试》面试概述（一）',
              teacher: '王弈珃',
              classHour: '10h',
              price: '￥300',
              experience: '免费试听',
              icon: topicTeacherImgs.kecheng_shiting,
            },
          ],
        },
      ],
    },
    {
      title: '中学',
      id: 3,
      active: false,
      itemsData: [
        {
          title: '教材精讲班',
          id: 1,
          active: true,
          classInfo: '梳理备考要点体系，搭建知识框架，扫除知识盲点',
          assortService: [
            { title: '权威题库', id: 1 },
            { title: '移动课堂', id: 2 },
            { title: '课程讲义', id: 3 },
            { title: '视频下载', id: 4 },
          ],
          validity: '12个月',
          courseList: [
            {
              id: 1,
              title: '《中学综合素质》教材精讲班',
              teacher: '陈龙',
              classHour: '25h',
              price: '￥100',
              experience: '免费试听',
              icon: topicTeacherImgs.kecheng_shiting,
            },
            {
              id: 2,
              title: '《中学教育教学与知识能力》教材精讲班',
              teacher: '雷智慧',
              classHour: '25h',
              price: '￥100',
              experience: '免费试听',
              icon: topicTeacherImgs.kecheng_shiting,
            },
            {
              id: 3,
              title: '《语文专业知识与教学能力》教材精讲班',
              teacher: '王瑜',
              classHour: '30h',
              price: '￥180',
              experience: '免费试听',
              icon: topicTeacherImgs.kecheng_shiting,
            },
            {
              id: 4,
              title: '《数学专业知识与教学能力》教材精讲班',
              teacher: '王涛',
              classHour: '30h',
              price: '￥180',
              experience: '免费试听',
              icon: topicTeacherImgs.kecheng_shiting,
            },
          ],
        },
        {
          title: '模拟试题班',
          id: 2,
          active: false,
          classInfo: '解题能力强化，模拟试卷检测，查漏补缺，加深理论理解，提高答题速度及正确率',
          assortService: [
            { title: '权威题库', id: 1 },
            { title: '移动课堂', id: 2 },
            { title: '课程讲义', id: 3 },
            { title: '视频下载', id: 4 },
          ],
          validity: '12个月',
          courseList: [
            {
              id: 1,
              title: '《中学综合素质》模拟试题班',
              teacher: '陈龙',
              classHour: '6h',
              price: '￥100',
              experience: '免费试听',
              icon: topicTeacherImgs.kecheng_shiting,
            },
            {
              id: 2,
              title: '《中学教育教学与知识能力》模拟试题班',
              teacher: '雷智慧',
              classHour: '6h',
              price: '￥100',
              experience: '免费试听',
              icon: topicTeacherImgs.kecheng_shiting,
            },
          ],
        },
        {
          title: '冲刺押题班',
          id: 3,
          active: false,
          classInfo: '提炼常考必考点，分类别讲授，点对点突破',
          assortService: [
            { title: '权威题库', id: 1 },
            { title: '移动课堂', id: 2 },
            { title: '课程讲义', id: 3 },
            { title: '视频下载', id: 4 },
          ],
          validity: '12个月',
          courseList: [
            {
              id: 1,
              title: '《中学综合素质》冲刺押题班',
              teacher: '陈龙',
              classHour: '3h',
              price: '￥100',
              experience: '免费试听',
              icon: topicTeacherImgs.kecheng_shiting,
            },
            {
              id: 2,
              title: '《中学教育教学与知识能力》冲刺押题班',
              teacher: '雷智慧',
              classHour: '3h',
              price: '￥100',
              experience: '免费试听',
              icon: topicTeacherImgs.kecheng_shiting,
            },
          ],
        },
        {
          title: '历年真题班',
          id: 4,
          active: false,
          classInfo: '结合近三年真题全解，巩固考点，总结答题“套路”应万变',
          assortService: [
            { title: '权威题库', id: 1 },
            { title: '移动课堂', id: 2 },
            { title: '课程讲义', id: 3 },
            { title: '视频下载', id: 4 },
          ],
          validity: '12个月',
          courseList: [
            {
              id: 1,
              title: '《中学综合素质》历年真题班',
              teacher: '陈龙',
              classHour: '4h',
              price: '￥100',
              experience: '免费试听',
              icon: topicTeacherImgs.kecheng_shiting,
            },
            {
              id: 2,
              title: '《中学教育教学与知识能力》历年真题班',
              teacher: '雷智慧',
              classHour: '4h',
              price: '￥100',
              experience: '免费试听',
              icon: topicTeacherImgs.kecheng_shiting,
            },
          ],
        },
        {
          title: '普通话测试',
          id: 5,
          active: false,
          classInfo: '考试流程题型及技巧分析，声韵母发音技巧指导',
          assortService: [
            { title: '权威题库', id: 1 },
            { title: '移动课堂', id: 2 },
            { title: '课程讲义', id: 3 },
            { title: '视频下载', id: 4 },
          ],
          validity: '12个月',
          courseList: [
            {
              id: 1,
              title: '《普通话测试》精讲班',
              teacher: '张凌薇',
              classHour: '3h',
              price: '￥100',
              experience: '免费试听',
              icon: topicTeacherImgs.kecheng_shiting,
            },
          ],
        },
        {
          title: '面试班',
          id: 6,
          active: false,
          classInfo: '结合面试考情，全面讲解结构化、试讲、说课和答辩各模块考核内容',
          assortService: [
            { title: '权威题库', id: 1 },
            { title: '移动课堂', id: 2 },
            { title: '课程讲义', id: 3 },
            { title: '视频下载', id: 4 },
          ],
          validity: '12个月',
          courseList: [
            {
              id: 1,
              title: '《中学面试》方向·路径（一）',
              teacher: '王弈珃',
              classHour: '10h',
              price: '￥300',
              experience: '免费试听',
              icon: topicTeacherImgs.kecheng_shiting,
            },
          ],
        },
      ],
    },
  ],
};

//教师资格证 - 行业优势
export const AdvantageData = {
  title: '行业优势',
  subtitle: '考个教师资格证，一年1/3都是带薪年假',
  name: 'advantage',
  url: topicTeacherImgs.tittle_industry,
  totalbackImg: topicTeacherImgs.industry_bg,
  list: [
    { id: 1, title: '薪资', subtitle: '国家事业编', tips: '工资不低于公务员' },
    { id: 2, title: '政策', subtitle: '《教师法》保障', tips: '大力扶持教师岗位' },
    { id: 3, title: '地位', subtitle: '工作性质稳定', tips: '社会地位极高' },
    { id: 4, title: '假期', subtitle: '周末双休', tips: '超长寒暑假' },
  ],
};

//教师资格证 - 提分体系
export const ScoringData = {
  title: '提分体系',
  subtitle: '三重提分体系，层层锁分，“100%”轻松过关',
  name: 'increaseScore',
  totalbackImg: topicTeacherImgs.scoring_bg,
  url: topicTeacherImgs.title_scoring,
  list: [
    {
      title: '全面夯实基础',
      id: 1,
      score: 50,
      active: true,
      subtitle: '基础阶段 - 教材精讲班',
      list: [
        {
          content: '班级作用：梳理学习思路，全面掌握考点',
          id: 1,
          icon: topicTeacherImgs.scoring_1,
        },
        {
          content: '班级作用：搭建知识框架，扫除知识盲点',
          id: 2,
          icon: topicTeacherImgs.scoring_2,
        },
        {
          content: '班级作用：全面夯实基础，吃透教材教辅',
          id: 3,
          icon: topicTeacherImgs.scoring_3,
        },
      ],
    },
    {
      title: '掌握核心考点',
      id: 2,
      score: 25,
      active: false,
      subtitle: '强化阶段 - 冲刺押题班',
      list: [
        {
          content: '班级作用：串讲高频考点，直击考题核心',
          id: 1,
          icon: topicTeacherImgs.scoring_1,
        },
        {
          content: '班级作用：快速攻克重难点，少丢分不丢分',
          id: 2,
          icon: topicTeacherImgs.scoring_2,
        },
        {
          content: '班级作用：掌握答题技巧，提高做题正确率',
          id: 3,
          icon: topicTeacherImgs.scoring_3,
        },
      ],
    },
    {
      title: '考前冲刺突击',
      id: 3,
      score: 25,
      active: false,
      subtitle: '冲刺阶段 - 历年真题班+模拟试题班',
      list: [
        {
          content: '班级作用：真题+模拟，讲练结合，双重突破',
          id: 1,
          icon: topicTeacherImgs.scoring_1,
        },
        { content: '班级作用：临考冲刺突击，强化巩固', id: 2, icon: topicTeacherImgs.scoring_2 },
        { content: '班级作用：考前摸底检测，查漏补缺', id: 3, icon: topicTeacherImgs.scoring_3 },
      ],
    },
  ],
};

//教师资格证 - 必备资料库
export const MustData = {
  title: '必备资料库',
  subtitle: '集合最全面的试题资料，全面助力教资考试',
  name: 'mustData',
  url: topicTeacherImgs.title_essential,
  list: [
    {
      title: '专业知识与教学能力',
      id: 1,
      active: true,
      inline_title: '2020教师资格证笔试',
      inline_tips:
        '笔试主要考察申请人从事教师职业所应具备的教育理念、职业道德和教育法律法规知识；科学文化素养和阅读理解、语言表达、逻辑推理和信息处理等基本能力；',
      inline_list: [
        { title: '课程1', content: '《教师资格证专业知识与教学能力复习讲义》', id: 1 },
        { title: '课程2', content: '《专业知识与教学能力考点汇总》', id: 2 },
        { title: '课程3', content: '《专业知识与教学能力大纲》', id: 3 },
      ],
      downloadData: [
        { title: '模拟卷', id: 1 },
        { title: '预测题', id: 2 },
        { title: '最新大纲', id: 3 },
        { title: '黄金考点', id: 4 },
        { title: '历年真题', id: 5 },
        { title: '课程讲义', id: 6 },
      ],
    },
    {
      title: '教育教学与知识能力',
      id: 2,
      active: false,
      inline_title: '2020教师资格证笔试',
      inline_tips:
        '笔试主要考察申请人从事教师职业所应具备的教育理念、职业道德和教育法律法规知识；科学文化素养和阅读理解、语言表达、逻辑推理和信息处理等基本能力；',
      inline_list: [
        { title: '课程1', content: '《教师资格证教育教学与知识能力复习讲义》', id: 1 },
        { title: '课程2', content: '《教育教学与知识能力考点汇总》', id: 2 },
        { title: '课程3', content: '《教育教学与知识能力大纲》', id: 3 },
      ],
      downloadData: [
        { title: '模拟卷', id: 1 },
        { title: '预测题', id: 2 },
        { title: '最新大纲', id: 3 },
        { title: '黄金考点', id: 4 },
        { title: '历年真题', id: 5 },
        { title: '课程讲义', id: 6 },
      ],
    },
    {
      title: '综合素质',
      id: 3,
      active: false,
      inline_title: '2020教师资格证笔试',
      inline_tips:
        '笔试主要考察申请人从事教师职业所应具备的教育理念、职业道德和教育法律法规知识；科学文化素养和阅读理解、语言表达、逻辑推理和信息处理等基本能力；',
      inline_list: [
        { title: '课程1', content: '《教师资格证综合素质复习讲义》', id: 1 },
        { title: '课程2', content: '《综合素质考点汇总》', id: 2 },
        { title: '课程3', content: '《综合素质大纲》', id: 3 },
      ],
      downloadData: [
        { title: '模拟卷', id: 1 },
        { title: '预测题', id: 2 },
        { title: '最新大纲', id: 3 },
        { title: '黄金考点', id: 4 },
        { title: '历年真题', id: 5 },
        { title: '课程讲义', id: 6 },
      ],
    },
  ],
};

//教师资格证 - 常见问题
export const CommonProblemData = {
  totalbackImg: topicTeacherImgs.problem_bg,
  title: '常见问题',
  subtitle: '',
  name: 'common',
  url: topicTeacherImgs.title_problem,
  list: [
    {
      title: '课程是否为最新版？',
      id: 1,
      contentList: [
        { content: '所有课程均为新版本，每年新教材上市或大纲修订，课程将及时更新。', id: 1 },
      ],
    },
    {
      title: '课程有效期是多久？',
      id: 2,
      contentList: [
        {
          content:
            '所有课程都设置了有效期，课程不同，有效期也不同，购买时可查看课程旁有效期提醒。课程有效期都是根据考试周期进行合理设定，具体详情请查看课程介绍。',
          id: 1,
        },
      ],
    },
    {
      title: '课程有什么优惠吗？',
      id: 3,
      contentList: [
        { content: '每个用户都有优惠卷可领取，领取后在领券中心查看，可用于抵扣订单金额。', id: 1 },
        { content: '组合课程最低优惠可至一折。', id: 2 },
      ],
    },
    {
      title: '课程怎么支付？',
      id: 4,
      contentList: [
        { content: '可以使用微信、支付宝、网银在线方式支付', id: 1 },
        {
          content:
            'PC端：打开百分网学习中心首页:<a href="http://100.wang">http://100.wang</a>，登录后点击待付款订单-去结算，提交订单-选择支付方式-支付成功。',
          id: 2,
        },
        {
          content: '移动端：打开百分优课小程序，点击右下角我的-登陆-点击待付款-确认付款-支付成功。',
          id: 3,
        },
      ],
    },
    {
      title: '外地户籍能否在本地参加考试?',
      id: 5,
      contentList: [
        { content: '人事关系外地的社会考生现场确认时，只需要提供本地居住证即可。', id: 1 },
        {
          content: '在本地就读的高校在校生，提供学生证以及所在学校开的学籍证明即可，无须居住证。',
          id: 2,
        },
      ],
    },
  ],
};

//教师资格证 - 移动课堂
export const MobileClassromData = {
  title: '移动课堂',
  subtitle: '学在掌心 / 随时随地 / 想学就学',
  tipsData: [
    { title: '实时更新，最新考点全get', id: 1 },
    { title: '所有课程购买后，均可反复观看，无二次收费', id: 2 },
    { title: '20000+丰富题库，海量资源，知识点尽在掌握', id: 3 },
  ],
  codeImg: topicTeacherImgs.sczx_code,
  totalbackImg: topicTeacherImgs.mobile_bg,
  backgroundImg: topicTeacherImgs.mobile_right_bg,
  leftImg: topicTeacherImgs.sczx_course_detail,
  codeTips: '微信扫一扫，开始学习',
};

//消防工程师 - 汇总数据
export const SummaryFireEngineerData = [
  { title: '精品课程', id: 1, content: '1246', icon: '分钟', right_icon: '/' },
  { title: '章节练习', id: 2, content: '354', icon: '题', right_icon: '/' },
  { title: '课程数量', id: 3, content: '46', icon: '个', right_icon: '/' },
  { title: '模考套题', id: 4, content: '23', icon: '套', right_icon: '/' },
  { title: '答疑周期', id: 5, content: '24', icon: '小时', right_icon: '/' },
  { title: '教学服务', id: 6, content: '720', icon: '天' },
];

//消防工程师 - 课程体系
export const FireEngineerCurriculumData = {
  list: [
    {
      id: 1,
      title: '无忧通关班',
      totalColor: 'red',
      recommendImg: topicFireEngineerImgs.course_hot,
      backgroundImg: topicFireEngineerImgs.course_class_red,
      subtitleImg: topicFireEngineerImgs.course_g_red,
      SuitableData: [
        { id: 1, content: '零基础或新参考生' },
        { id: 2, content: '自制力差需要督促的考生' },
        { id: 3, content: '想一次过全科，追求性价比的考生' },
      ],
      CourseContentData: [
        {
          id: 1,
          title: '全科',
          list: [
            { id: 1, content: '综合能力+案例分析+技术实务' },
            { id: 2, content: '消防规范+消防三合一' },
          ],
        },
      ],
      ServiceAssuranceData: [
        {
          id: 1,
          title: '班级保障',
          list: [
            { id: 1, content: '报名日起2年内有效' },
            { id: 2, content: '免费重学1次（考试未过可享，重学次年新版课程）' },
            {
              id: 3,
              content: '课程有效期内笔试未过，退课程差价100元（如因个人原因缺课，则不退费）',
            },
          ],
        },
        { id: 2, title: '服务承诺', url: topicFireEngineerImgs.course_7_red },
      ],
      IncludeClassData: [
        {
          id: 1,
          title: '基础阶段',
          list: [
            { content: '基础导学班', icon: topicTeacherImgs.kecheng_shiting, id: 1 },
            { content: '教材精讲班', icon: topicTeacherImgs.kecheng_shiting, id: 2 },
          ],
        },
        {
          id: 2,
          title: '强化阶段',
          list: [{ content: '习题班', icon: topicTeacherImgs.kecheng_shiting, id: 1 }],
        },
        {
          id: 3,
          title: '冲刺阶段',
          list: [
            { content: '冲刺串讲班', icon: topicTeacherImgs.kecheng_shiting, id: 1 },
            { content: '模拟押题班', icon: topicTeacherImgs.kecheng_shiting, id: 2 },
            { content: '真题解析班', icon: topicTeacherImgs.kecheng_shiting, id: 3 },
          ],
        },
      ],
      CourseBenefitsData: [
        {
          id: 1,
          icon: topicFireEngineerImgs.course_x_yellow,
          content: '超值优惠最低<span style="color: #eaaa2d; font-weight: bold;">低至三折</span>',
        },
        { id: 2, icon: topicFireEngineerImgs.course_x_yellow, content: '老师24小时答疑' },
        { id: 3, icon: topicFireEngineerImgs.course_x_yellow, content: '考试重点消息短信通知' },
        { id: 4, icon: topicFireEngineerImgs.course_x_yellow, content: '交流学习群' },
        { id: 5, icon: topicFireEngineerImgs.course_give, content: '权威收费题库' },
        { id: 6, icon: topicFireEngineerImgs.course_give, content: '考前小宝典' },
        { id: 7, icon: topicFireEngineerImgs.course_give, content: '全科黄金考点' },
        { id: 8, icon: topicFireEngineerImgs.course_give, content: '量身定制专属学习计划' },
        { id: 9, icon: topicFireEngineerImgs.course_give, content: '精制版课程讲义' },
      ],
      combinPriceList: [{ id: 1, price: '2688', tips: '' }],
    },
    {
      id: 2,
      title: '基础套餐班',
      totalColor: 'blue',
      recommendImg: '',
      backgroundImg: topicFireEngineerImgs.course_class_blue,
      subtitleImg: topicFireEngineerImgs.course_g_blue,
      SuitableData: [
        { id: 1, content: '基础相对薄弱的新老考生' },
        { id: 2, content: '单科突破，想要定点辅导的考生' },
        { id: 3, content: '参加过考试，有考试经验的考生' },
      ],
      CourseContentData: [
        {
          id: 1,
          title: '全科',
          list: [{ id: 1, content: '综合能力+案例分析+技术实务' }],
        },
        {
          id: 2,
          title: '单科',
          list: [{ id: 1, content: '三科自选' }],
        },
      ],
      ServiceAssuranceData: [
        {
          id: 1,
          title: '班级保障',
          list: [
            { id: 1, content: '报名日起2年内有效' },
            { id: 2, content: '免费重学1次（考试未过可享，重学次年新版课程）' },
          ],
        },
        { id: 2, title: '服务承诺', url: topicFireEngineerImgs.course_7_blue },
      ],
      IncludeClassData: [
        {
          id: 1,
          title: '基础阶段',
          list: [
            { content: '入门导学班（单/全科)', icon: topicTeacherImgs.kecheng_shiting, id: 1 },
            { content: '教材精讲班（单/全科）', icon: topicTeacherImgs.kecheng_shiting, id: 2 },
          ],
        },
        {
          id: 2,
          title: '强化阶段',
          list: [{ content: '习题班（单/全科）', icon: topicTeacherImgs.kecheng_shiting, id: 1 }],
        },
        {
          id: 3,
          title: '冲刺阶段',
          list: [
            { content: '真题解析班（单/全科）', icon: topicTeacherImgs.kecheng_shiting, id: 1 },
          ],
        },
      ],
      CourseBenefitsData: [
        { id: 1, icon: topicFireEngineerImgs.course_x_blue, content: '老师24小时答疑' },
        { id: 2, icon: topicFireEngineerImgs.course_x_blue, content: '考试重点消息短信通知' },
        { id: 3, icon: topicFireEngineerImgs.course_x_blue, content: '交流学习群' },
        { id: 4, icon: topicFireEngineerImgs.course_give, content: '权威收费题库' },
        { id: 5, icon: topicFireEngineerImgs.course_give, content: '全科黄金考点' },
        { id: 6, icon: topicFireEngineerImgs.course_give, content: '精制版课程讲义' },
      ],
      combinPriceList: [
        { id: 1, price: '2688', tips: '（全科）' },
        { id: 2, price: '500', tips: '（单科）' },
      ],
    },
    {
      id: 3,
      title: '教材精讲班',
      totalColor: 'green',
      recommendImg: '',
      backgroundImg: topicFireEngineerImgs.course_class_green,
      subtitleImg: topicFireEngineerImgs.course_g_green,
      SuitableData: [
        { id: 1, content: '从事相关行业有一定基础，想从60分突破72分以上的考生' },
        { id: 2, content: '学习自律性强的考生' },
      ],
      CourseContentData: [
        {
          id: 1,
          title: '全科',
          list: [
            { id: 1, content: '综合能力+案例分析+技术实务' },
            { id: 2, content: '消防规范+消防三合一' },
          ],
        },
      ],
      ServiceAssuranceData: [
        {
          id: 1,
          title: '班级保障',
          list: [{ id: 1, content: '报名日起1年内有效' }],
        },
        { id: 2, title: '服务承诺', url: topicFireEngineerImgs.course_7_green },
      ],
      IncludeClassData: [
        {
          id: 1,
          title: '基础阶段',
          list: [{ content: '教材精讲班', icon: topicTeacherImgs.kecheng_shiting, id: 1 }],
        },
      ],
      CourseBenefitsData: [
        { id: 1, icon: topicFireEngineerImgs.course_x_green, content: '老师24小时答疑' },
        { id: 2, icon: topicFireEngineerImgs.course_x_green, content: '交流学习群' },
        { id: 3, icon: topicFireEngineerImgs.course_give, content: '精制版课程讲义' },
      ],
      combinPriceList: [{ id: 1, price: '2000', tips: '' }],
    },
  ],
  title: '课程体系',
  subtitle: '不同班型，总有一款适合你，零基础也能过消防！',
  name: 'curriculum',
  backgroundImg: topicFireEngineerImgs.title_course,
  totalbackImg: topicFireEngineerImgs.course_bg_bg,
  width: '545px',
};

//消防工程师 - 单选班级
export const FireEngineerClassData = {
  title: '单选班级',
  subtitle: '2020消防工程师单科辅导课程，可单独购买',
  name: 'class',
  totalbackImg: topicFireEngineerImgs.class_bg,
  backgroundImg: topicFireEngineerImgs.title_class,
  width: '596px',
  list: [
    {
      title: '基础导学班',
      id: 1,
      active: true,
      classInfo: '零基础入门，帮助学生梳理学习思路及备考指导',
      assortService: [
        { title: '权威题库', id: 1 },
        { title: '移动课堂', id: 2 },
        { title: '课程讲义', id: 3 },
        { title: '视频下载', id: 4 },
      ],
      validity: '12个月',
      courseList: [
        {
          id: 1,
          title: '《综合能力/案例分析通用》导学班',
          teacher: '刘为国',
          classHour: '2h',
          price: '￥100',
          experience: '免费试听',
          icon: topicTeacherImgs.kecheng_shiting,
        },
        {
          id: 2,
          title: '《消防安全技术实务》导学班',
          teacher: '/',
          classHour: '25h',
          price: '￥100',
          experience: '免费试听',
          icon: topicTeacherImgs.kecheng_shiting,
        },
      ],
    },
    {
      title: '教材精讲班',
      id: 2,
      active: false,
      classInfo: '梳理备考要点体系，搭建知识框架，扫除知识盲点',
      assortService: [
        { title: '权威题库', id: 1 },
        { title: '移动课堂', id: 2 },
        { title: '课程讲义', id: 3 },
        { title: '视频下载', id: 4 },
      ],
      validity: '12个月',
      courseList: [
        {
          id: 1,
          title: '《消防技术综合能力》教材精讲班',
          teacher: '王冬亮',
          classHour: '20h',
          price: '￥320',
          experience: '免费试听',
          icon: topicTeacherImgs.kecheng_shiting,
        },
        {
          id: 2,
          title: '《消防安全案例分析》教材精讲班',
          teacher: '刘为国',
          classHour: '25h',
          price: '￥320',
          experience: '免费试听',
          icon: topicTeacherImgs.kecheng_shiting,
        },
        {
          id: 3,
          title: '《消防安全技术实务》教材精讲班',
          teacher: '宿吉南',
          classHour: '30h',
          price: '￥320',
          experience: '免费试听',
          icon: topicTeacherImgs.kecheng_shiting,
        },
        {
          id: 4,
          title: '《消防规范》教材精讲班',
          teacher: '/',
          classHour: '/',
          price: '￥520',
          experience: '免费试听',
          icon: topicTeacherImgs.kecheng_shiting,
        },
        {
          id: 5,
          title: '《消防三合一》教材精讲班',
          teacher: '余兴华',
          classHour: '25h',
          price: '￥520',
          experience: '免费试听',
          icon: topicTeacherImgs.kecheng_shiting,
        },
      ],
    },
    {
      title: '冲刺串讲班',
      id: 3,
      active: false,
      classInfo: '提炼常考必考点，分类别讲授，点对点突破',
      assortService: [
        { title: '权威题库', id: 1 },
        { title: '移动课堂', id: 2 },
        { title: '课程讲义', id: 3 },
        { title: '视频下载', id: 4 },
      ],
      validity: '12个月',
      courseList: [
        {
          id: 1,
          title: '《消防技术综合能力》冲刺串讲班',
          teacher: '王冬亮',
          classHour: '5h',
          price: '￥180',
          experience: '免费试听',
          icon: topicTeacherImgs.kecheng_shiting,
        },
        {
          id: 2,
          title: '《消防安全技术实务》冲刺串讲班',
          teacher: '宿吉南',
          classHour: '5h',
          price: '￥180',
          experience: '免费试听',
          icon: topicTeacherImgs.kecheng_shiting,
        },
      ],
    },
    {
      title: '模拟押题班',
      id: 4,
      active: false,
      classInfo: '结合模拟试卷，巩固考点',
      assortService: [
        { title: '权威题库', id: 1 },
        { title: '移动课堂', id: 2 },
        { title: '课程讲义', id: 3 },
        { title: '视频下载', id: 4 },
      ],
      validity: '12个月',
      courseList: [
        {
          id: 1,
          title: '《消防技术综合能力》模拟押题班',
          teacher: '王冬亮',
          classHour: '4h',
          price: '￥100',
          experience: '免费试听',
          icon: topicTeacherImgs.kecheng_shiting,
        },
        {
          id: 2,
          title: '《消防安全技术实务》模拟押题班',
          teacher: '宿吉南',
          classHour: '4h',
          price: '￥100',
          experience: '免费试听',
          icon: topicTeacherImgs.kecheng_shiting,
        },
        {
          id: 3,
          title: '《消防安全案例分析》模拟押题班',
          teacher: '刘为国',
          classHour: '4h',
          price: '￥100',
          experience: '免费试听',
          icon: topicTeacherImgs.kecheng_shiting,
        },
      ],
    },
    {
      title: '真题解析班',
      id: 5,
      active: false,
      classInfo: '结合近三年真题全解，提炼重点，总结答题“套路”应万变',
      assortService: [
        { title: '权威题库', id: 1 },
        { title: '移动课堂', id: 2 },
        { title: '课程讲义', id: 3 },
        { title: '视频下载', id: 4 },
      ],
      validity: '12个月',
      courseList: [
        {
          id: 1,
          title: '《消防技术综合能力》真题解析班',
          teacher: '王冬亮',
          classHour: '6h',
          price: '￥100',
          experience: '免费试听',
          icon: topicTeacherImgs.kecheng_shiting,
        },
        {
          id: 2,
          title: '《消防安全技术实务》真题解析班',
          teacher: '宿吉南',
          classHour: '6h',
          price: '￥100',
          experience: '免费试听',
          icon: topicTeacherImgs.kecheng_shiting,
        },
        {
          id: 3,
          title: '《消防安全案例分析》真题解析班',
          teacher: '刘为国',
          classHour: '6h',
          price: '￥100',
          experience: '免费试听',
          icon: topicTeacherImgs.kecheng_shiting,
        },
      ],
    },
    {
      title: '习题班',
      id: 6,
      active: false,
      classInfo: '解题能力强化，模拟试卷检测，查漏补缺，加深理论理解，提高答题速度及正确率',
      assortService: [
        { title: '权威题库', id: 1 },
        { title: '移动课堂', id: 2 },
        { title: '课程讲义', id: 3 },
        { title: '视频下载', id: 4 },
      ],
      validity: '12个月',
      courseList: [
        {
          id: 1,
          title: '《消防技术综合能力》习题班',
          teacher: '王冬亮',
          classHour: '4h',
          price: '￥120',
          experience: '免费试听',
          icon: topicTeacherImgs.kecheng_shiting,
        },
        {
          id: 2,
          title: '《消防安全技术实务》习题班',
          teacher: '宿吉南',
          classHour: '4h',
          price: '￥120',
          experience: '免费试听',
          icon: topicTeacherImgs.kecheng_shiting,
        },
        {
          id: 3,
          title: '《消防安全案例分析》习题班',
          teacher: '刘为国',
          classHour: '4h',
          price: '￥120',
          experience: '免费试听',
          icon: topicTeacherImgs.kecheng_shiting,
        },
      ],
    },
  ],
};

//消防工程师 - 证书价值
export const CertificateData = {
  title: '证书价值',
  subtitle: '考消防工程师证书，坐拥年薪20w+',
  name: 'certificate',
  totalbackImg: topicFireEngineerImgs.certificate_bg,
  backgroundImg: topicFireEngineerImgs.title_certificate,
  width: '839px',
  list: [
    {
      id: 1,
      title: '升职加薪',
      content: '获得一级注册消防工程师，可立即聘为工程师、担任项目经理、项目负责人、技术负责人等。',
    },
    {
      id: 2,
      title: '市场需求',
      content: '注册消防工程师数量少，需求量大，需求面广，未来3-5年，需要50万注册消防工程师。',
    },
    {
      id: 3,
      title: '含金量高',
      content: '公安部、消防局、人社局联合认证，注册证书价值10-20万/年。',
    },
  ],
};

//消防工程师 - 在线题库
export const QuestionBankData = {
  title: '在线题库',
  subtitle: '历年真题精华+命题规律解析+新增考点预测',
  name: 'questionbank',
  backgroundImg: topicFireEngineerImgs.title_question,
  width: '801px',
  list: [
    {
      id: 1,
      title: '模拟试卷',
      active: true,
      list: [
        {
          id: 1,
          title: '2019年消防工程师考试《消防安全技术实务》模拟测试卷（一）',
          person: 324,
          diff: 5,
          icon: '模',
        },
        {
          id: 2,
          title: '2019年消防工程师考试《消防安全技术实务》模拟测试卷（二）',
          person: 297,
          diff: 5,
          icon: '模',
        },
        {
          id: 3,
          title: '2019年消防工程师考试《消防安全案例分析》模拟测试卷（一）',
          person: 324,
          diff: 5,
          icon: '模',
        },
        {
          id: 4,
          title: '2019年消防工程师考试《消防安全案例分析》模拟测试卷（二）',
          person: 324,
          diff: 5,
          icon: '模',
        },
      ],
    },
    {
      id: 2,
      title: '章节练习',
      active: false,
      list: [
        {
          id: 1,
          title: '第一章    消防法及相关法律与消防执业道德',
          person: '',
          diff: '',
          icon: '章',
        },
        { id: 2, title: '第二章    建筑防火', person: '', diff: '', icon: '章' },
        { id: 3, title: '第三章    设施安装、检测与维护保养', person: '', diff: '', icon: '章' },
        { id: 4, title: '第四章    消防安全评估', person: '', diff: '', icon: '章' },
      ],
    },
    {
      id: 3,
      title: '历年真题',
      active: false,
      list: [
        {
          id: 1,
          title: '2018年消防工程师考试《消防安全技术实务》真题及答案',
          person: 966,
          diff: 5,
          icon: '真',
        },
        {
          id: 2,
          title: '2019年消防工程师考试《消防安全技术实务》真题及答案',
          person: 744,
          diff: 5,
          icon: '真',
        },
        {
          id: 3,
          title: '2018年消防工程师考试《消防安全案例分析》真题及答案',
          person: 1064,
          diff: 5,
          icon: '真',
        },
        {
          id: 4,
          title: '2019年消防工程师考试《消防安全案例分析》真题及答案',
          person: 1266,
          diff: 5,
          icon: '真',
        },
      ],
    },
    {
      id: 4,
      title: '每日一练',
      active: false,
      list: [
        { id: 1, title: '消防安全技术实务', person: 53, diff: '', icon: '练' },
        { id: 2, title: '消防安全案例分析', person: 42, diff: '', icon: '练' },
        { id: 3, title: '消防技术综合能力', person: 73, diff: '', icon: '练' },
        { id: 4, title: '消防三合一', person: 24, diff: '', icon: '练' },
      ],
    },
  ],
};

//消防工程师 - 自学VS百分网
export const PercentData = {
  title: '自学VS百分网',
  subtitle: '用数据说话，让通过率给你信心',
  name: 'percent',
  totalbackImg: topicFireEngineerImgs.percent_bg,
  backgroundImg: topicFireEngineerImgs.title_percent,
  width: '755px',
  height: '884px',
  subtitleImg: topicFireEngineerImgs.percent_title_bg,
  list: [
    {
      id: 1,
      title: '时间对比',
      subtitle: '用更短的时间，掌握更多知识点',
      showImg: topicFireEngineerImgs.percent_data_time,
      titleMask: topicFireEngineerImgs.percent_g_yellow,
      first_posi_title: '100%知识点掌握',
      second_posi_title: '20%知识点掌握',
    },
    {
      id: 2,
      title: '学习效果',
      subtitle: '用分数提高，让进步肉眼可见',
      showImg: topicFireEngineerImgs.percent_data_Learn,
      titleMask: topicFireEngineerImgs.percent_g_yellow,
      first_posi_title: '',
      second_posi_title: '',
    },
    {
      id: 3,
      title: '通过率',
      subtitle: '用10倍通过率，给你选择的理由',
      showImg: topicFireEngineerImgs.percent_data_passing,
      titleMask: topicFireEngineerImgs.percent_g_yellow,
      first_posi_title: '70%通过率',
      second_posi_title: '7%通过率',
    },
  ],
};

//消防工程师 - 常见问题
export const CommonQuestionData = {
  title: '常见问题',
  subtitle: '',
  name: 'common',
  backgroundImg: topicFireEngineerImgs.title_problem,
  width: '415px',
  list: [
    {
      title: '课程是否为最新版？',
      id: 1,
      contentList: [
        { content: '所有课程均为新版本，每年新教材上市或大纲修订，课程将及时更新。', id: 1 },
      ],
    },
    {
      title: '课程有效期是多久？',
      id: 2,
      contentList: [
        {
          content:
            '所有课程都设置了有效期，课程不同，有效期也不同，购买时可查看课程旁有效期提醒。课程有效期都是根据考试周期进行合理设定，具体详情请查看课程介绍。',
          id: 1,
        },
      ],
    },
    {
      title: '课程有什么优惠吗？',
      id: 3,
      contentList: [
        { content: '每个用户都有优惠卷可领取，领取后在领券中心查看，可用于抵扣订单金额。', id: 1 },
        { content: '组合课程最低优惠可至一折。', id: 2 },
      ],
    },
    {
      title: '课程怎么支付？',
      id: 4,
      contentList: [
        { content: '可以使用微信、支付宝、网银在线方式支付', id: 1 },
        {
          content:
            'PC端：打开百分网学习中心首页:<a href="http://100.wang">http://100.wang</a>，登录后点击待付款订单-去结算，提交订单-选择支付方式-支付成功。',
          id: 2,
        },
        {
          content: '移动端：打开百分优课小程序，点击右下角我的-登陆-点击待付款-确认付款-支付成功。',
          id: 3,
        },
      ],
    },
  ],
};

//消防工程师 - 移动课堂
export const FireEngineerMobileClassromData = {
  title: '移动课堂',
  subtitle: '学在掌心 / 随时随地 / 想学就学',
  tipsData: [
    { title: '实时更新，最新考点全get', id: 1 },
    { title: '所有课程购买后，均可反复观看，无二次收费', id: 2 },
    { title: '20000+丰富题库，海量资源，知识点尽在掌握', id: 3 },
  ],
  codeImg: topicTeacherImgs.sczx_code,
  leftImg: topicTeacherImgs.sczx_course_detail,
  totalbackImg: topicFireEngineerImgs.mobile_bg,
  backgroundImg: topicFireEngineerImgs.mobile_classroom_bg,
  codeTips: '微信扫一扫，开始学习',
};

//执业药师 - 汇总数据
export const SummaryLicensedPharmacistData = [
  { title: '精品课程', id: 1, content: '965', icon: '分钟', right_icon: '/' },
  { title: '章节练习', id: 2, content: '274', icon: '题', right_icon: '/' },
  { title: '课程数量', id: 3, content: '28', icon: '个', right_icon: '/' },
  { title: '模考套题', id: 4, content: '15', icon: '套', right_icon: '/' },
  { title: '答疑周期', id: 5, content: '24', icon: '小时', right_icon: '/' },
  { title: '教学服务', id: 6, content: '720', icon: '天' },
];

//执业药师 - 课程体系
export const LicensedPharmacistCurriculumData = {
  list: [
    {
      id: 1,
      title: '高端取证班',
      totalColor: 'red',
      recommendImg: topicFireEngineerImgs.course_hot,
      backgroundImg: topicFireEngineerImgs.course_class_red,
      subtitleImg: topicFireEngineerImgs.course_g_red,
      SuitableData: [
        { id: 1, content: '零基础或新参考生' },
        { id: 2, content: '追求课程性价比的考生' },
        { id: 3, content: '自制力差，需要监督的考生' },
      ],
      CourseContentData: [
        {
          id: 1,
          title: '全科',
          list: [{ id: 1, content: '中药+西药' }],
        },
        {
          id: 2,
          title: '单科',
          list: [{ id: 1, content: '8课自选' }],
        },
      ],
      ServiceAssuranceData: [
        {
          id: 1,
          title: '班级保障',
          list: [
            { id: 1, content: '报名日起2年内有效' },
            { id: 2, content: '免费重学1次（考试未过可享，重学次年新版课程）' },
            {
              id: 3,
              content: '课程有效期内笔试未过，退课程差价100元（如因个人原因缺课，则不退费）',
            },
          ],
        },
        { id: 2, title: '服务承诺', url: topicFireEngineerImgs.course_7_red },
      ],
      IncludeClassData: [
        {
          id: 1,
          title: '基础阶段',
          list: [
            { content: '基础入门班', icon: topicTeacherImgs.kecheng_shiting, id: 1 },
            { content: '教材精讲班', icon: topicTeacherImgs.kecheng_shiting, id: 2 },
          ],
        },
        {
          id: 2,
          title: '强化阶段',
          list: [
            { content: '冲刺押题班', icon: topicTeacherImgs.kecheng_shiting, id: 1 },
            { content: '习题班', icon: topicTeacherImgs.kecheng_shiting, id: 2 },
          ],
        },
        {
          id: 3,
          title: '冲刺阶段',
          list: [{ content: '模拟押题班', icon: topicTeacherImgs.kecheng_shiting, id: 1 }],
        },
      ],
      CourseBenefitsData: [
        {
          id: 1,
          icon: topicFireEngineerImgs.course_x_yellow,
          content: '超值优惠最低<span style="color: #eaaa2d; font-weight: bold;">低至三折</span>',
        },
        { id: 2, icon: topicFireEngineerImgs.course_x_yellow, content: '老师24小时答疑' },
        { id: 3, icon: topicFireEngineerImgs.course_x_yellow, content: '考试重点消息短信通知' },
        { id: 4, icon: topicFireEngineerImgs.course_x_yellow, content: '交流学习群' },
        { id: 5, icon: topicFireEngineerImgs.course_give, content: '权威收费题库' },
        { id: 6, icon: topicFireEngineerImgs.course_give, content: '考前小宝典' },
        { id: 7, icon: topicFireEngineerImgs.course_give, content: '全科黄金考点' },
        { id: 8, icon: topicFireEngineerImgs.course_give, content: '量身定制专属学习计划' },
        { id: 9, icon: topicFireEngineerImgs.course_give, content: '精制版课程讲义' },
      ],
      combinPriceList: [
        { id: 1, price: '1280', tips: '（全科）' },
        { id: 2, price: '420', tips: '（单科）' },
      ],
    },
    {
      id: 2,
      title: '基础套餐班',
      totalColor: 'blue',
      recommendImg: '',
      backgroundImg: topicFireEngineerImgs.course_class_blue,
      subtitleImg: topicFireEngineerImgs.course_g_blue,
      SuitableData: [
        { id: 1, content: '基础相对薄弱的新老考生' },
        { id: 2, content: '基础突破，需要系统的辅导的考生' },
        { id: 3, content: '参加过考试，有考试经验的考生' },
      ],
      CourseContentData: [
        {
          id: 1,
          title: '全科',
          list: [{ id: 1, content: '中药+西药 ' }],
        },
        {
          id: 2,
          title: '单科',
          list: [{ id: 1, content: '8科自选' }],
        },
      ],
      ServiceAssuranceData: [
        {
          id: 1,
          title: '班级保障',
          list: [
            { id: 1, content: '报名日起2年内有效' },
            { id: 2, content: '免费重学1次（考试未过可享，重学次年新版课程）' },
          ],
        },
        { id: 2, title: '服务承诺', url: topicFireEngineerImgs.course_7_blue },
      ],
      IncludeClassData: [
        {
          id: 1,
          title: '基础阶段',
          list: [
            { content: '基础入门班', icon: topicTeacherImgs.kecheng_shiting, id: 1 },
            { content: '教材精讲班', icon: topicTeacherImgs.kecheng_shiting, id: 2 },
          ],
        },
        {
          id: 2,
          title: '强化阶段',
          list: [{ content: '冲刺押题班', icon: topicTeacherImgs.kecheng_shiting, id: 1 }],
        },
        {
          id: 3,
          title: '冲刺阶段',
          list: [{ content: '模拟押题班', icon: topicTeacherImgs.kecheng_shiting, id: 1 }],
        },
      ],
      CourseBenefitsData: [
        { id: 1, icon: topicFireEngineerImgs.course_x_blue, content: '老师24小时答疑' },
        { id: 2, icon: topicFireEngineerImgs.course_x_blue, content: '考试重点消息短信通知' },
        { id: 3, icon: topicFireEngineerImgs.course_x_blue, content: '交流学习群' },
        { id: 4, icon: topicFireEngineerImgs.course_give, content: '权威收费题库' },
        { id: 5, icon: topicFireEngineerImgs.course_give, content: '全科黄金考点' },
        { id: 6, icon: topicFireEngineerImgs.course_give, content: '精制版课程讲义' },
      ],
      combinPriceList: [
        { id: 1, price: '880', tips: '（全科）' },
        { id: 2, price: '320', tips: '（单科）' },
      ],
    },
    {
      id: 3,
      title: '教材精讲班',
      totalColor: 'green',
      recommendImg: '',
      backgroundImg: topicFireEngineerImgs.course_class_green,
      subtitleImg: topicFireEngineerImgs.course_g_green,
      SuitableData: [
        { id: 1, content: '从事过医药相关工作的考生' },
        { id: 2, content: '完成基础复习的考生' },
        { id: 3, content: '学习自律性强的考生' },
      ],
      CourseContentData: [
        {
          id: 1,
          title: '全科',
          list: [{ id: 1, content: '中药+西药' }],
        },
        {
          id: 2,
          title: '单科',
          list: [{ id: 1, content: '8课自选' }],
        },
      ],
      ServiceAssuranceData: [
        {
          id: 1,
          title: '班级保障',
          list: [{ id: 1, content: '报名日起1年内有效' }],
        },
        { id: 2, title: '服务承诺', url: topicFireEngineerImgs.course_7_green },
      ],
      IncludeClassData: [
        {
          id: 1,
          title: '基础阶段',
          list: [{ content: '教材精讲班', icon: topicTeacherImgs.kecheng_shiting, id: 1 }],
        },
      ],
      CourseBenefitsData: [
        { id: 1, icon: topicFireEngineerImgs.course_x_green, content: '老师24小时答疑' },
        { id: 2, icon: topicFireEngineerImgs.course_x_green, content: '交流学习群' },
        { id: 3, icon: topicFireEngineerImgs.course_give, content: '精制版课程讲义' },
      ],
      combinPriceList: [
        { id: 1, price: '1120', tips: '（全科）' },
        { id: 2, price: '280', tips: '（单科）' },
      ],
    },
  ],
  title: '课程体系',
  subtitle: '经典班次选你所需，解决您的备考烦恼',
  name: 'curriculum',
  backgroundImg: topicLicensedPharmacistImgs.title_course,
  totalbackImg: topicLicensedPharmacistImgs.course_bg_bgg,
  width: '545px',
};

//执业药师 - 单选班级
export const LicensedPharmacistClassData = {
  title: '单选班级',
  subtitle: '2020执业药师单科辅导课程，可单独购买',
  name: 'class',
  totalbackImg: topicLicensedPharmacistImgs.class_bg,
  backgroundImg: topicLicensedPharmacistImgs.tlttle_class,
  width: '596px',
  list: [
    {
      id: 1, title: '中药', active: true, itemsData: [
        {
          title: '教材精讲班', id: 1, active: true, classInfo: '梳理备考要点体系，搭建知识框架，扫除知识盲点', assortService: [
            { title: '权威题库', id: 1 },
            { title: '移动课堂', id: 2 },
            { title: '课程讲义', id: 3 },
            { title: '视频下载', id: 4 }
          ],
          validity: '12个月',
          courseList: [
            { id: 1, title: '中药《药学专业知识（一）》教材精讲班', teacher: '常青/姜雅', classHour: '20h', price: '￥280', experience: '免费试听', icon: topicTeacherImgs.kecheng_shiting },
            { id: 2, title: '中药《药学专业知识（二）》教材精讲班', teacher: '冯得润/徐一鸣', classHour: '20h', price: '￥280', experience: '免费试听', icon: topicTeacherImgs.kecheng_shiting },
            { id: 3, title: '中药《综合知识与技能》教材精讲班', teacher: '桑碧瞳', classHour: '20h', price: '￥280', experience: '免费试听', icon: topicTeacherImgs.kecheng_shiting },
            { id: 4, title: '中药《药事管理与法规》教材精讲班', teacher: '衣铖', classHour: '22h', price: '￥280', experience: '免费试听', icon: topicTeacherImgs.kecheng_shiting },
          ]
        },
        {
          title: '冲刺押题班', id: 2, active: false, classInfo: '串讲核心考点，短期快速提分', assortService: [
            { title: '权威题库', id: 1 },
            { title: '移动课堂', id: 2 },
            { title: '课程讲义', id: 3 },
            { title: '视频下载', id: 4 }
          ],
          validity: '12个月',
          courseList: [
            { id: 1, title: '中药《药学专业知识（一）》冲刺押题班', teacher: '常青/姜雅', classHour: '7.5h', price: '￥100', experience: '免费试听', icon: topicTeacherImgs.kecheng_shiting },
            { id: 2, title: '中药《药学专业知识（二）》冲刺押题班', teacher: '冯得润/徐一鸣', classHour: '7.5h', price: '￥100', experience: '免费试听', icon: topicTeacherImgs.kecheng_shiting },
            { id: 3, title: '中药《综合知识与技能》冲刺押题班', teacher: '桑碧瞳', classHour: '7.5h', price: '￥100', experience: '免费试听', icon: topicTeacherImgs.kecheng_shiting },
            { id: 4, title: '中药《药事管理与法规》冲刺押题班', teacher: '衣铖', classHour: '7.5h', price: '￥100', experience: '免费试听', icon: topicTeacherImgs.kecheng_shiting },
          ]
        },
        {
          title: '模拟押题班', id: 3, active: false, classInfo: '识别知识误区，避免考试落入陷阱，进入临考状态。', assortService: [
            { title: '权威题库', id: 1 },
            { title: '移动课堂', id: 2 },
            { title: '课程讲义', id: 3 },
            { title: '视频下载', id: 4 }
          ],
          validity: '12个月',
          courseList: [
            { id: 1, title: '中药《药学专业知识（一）》模拟押题班', teacher: '常青/姜雅', classHour: '2h', price: '￥100', experience: '免费试听', icon: topicTeacherImgs.kecheng_shiting },
            { id: 2, title: '中药《药学专业知识（二）》模拟押题班', teacher: '冯得润/徐一鸣', classHour: '2h', price: '￥100', experience: '免费试听', icon: topicTeacherImgs.kecheng_shiting },
            { id: 3, title: '中药《综合知识与技能》模拟押题班', teacher: '桑碧瞳', classHour: '2h', price: '￥100', experience: '免费试听', icon: topicTeacherImgs.kecheng_shiting },
            { id: 4, title: '中药《药事管理与法规》模拟押题班', teacher: '衣铖', classHour: '2h', price: '￥100', experience: '免费试听', icon: topicTeacherImgs.kecheng_shiting },
          ]
        },
        {
          title: '习题班', id: 4, active: false, classInfo: '讲解权威试题，并对知识点延伸，举一反三，学以致用。', assortService: [
            { title: '权威题库', id: 1 },
            { title: '移动课堂', id: 2 },
            { title: '课程讲义', id: 3 },
            { title: '视频下载', id: 4 }
          ],
          validity: '12个月',
          courseList: [
            { id: 1, title: '中药《药学专业知识（一）》习题班', teacher: '常青/姜雅', classHour: '4h', price: '￥100', experience: '免费试听', icon: topicTeacherImgs.kecheng_shiting },
            { id: 2, title: '中药《药学专业知识（二）》习题班', teacher: '冯得润/徐一鸣', classHour: '4h', price: '￥100', experience: '免费试听', icon: topicTeacherImgs.kecheng_shiting },
            { id: 3, title: '中药《综合知识与技能》习题班', teacher: '桑碧瞳', classHour: '4h', price: '￥100', experience: '免费试听', icon: topicTeacherImgs.kecheng_shiting },
            { id: 4, title: '中药《药事管理与法规》习题班', teacher: '衣铖', classHour: '4h', price: '￥100', experience: '免费试听', icon: topicTeacherImgs.kecheng_shiting },
          ]
        }
      ]
    },
    {
      id: 2, title: '西药', active: false, itemsData: [
        {
          title: '基础入门班', id: 1, active: true, classInfo: '零基础入门，帮助学生梳理学习思路及备考指导', assortService: [
            { title: '权威题库', id: 1 },
            { title: '移动课堂', id: 2 },
            { title: '课程讲义', id: 3 },
            { title: '视频下载', id: 4 }
          ],
          validity: '12个月',
          courseList: [
            { id: 1, title: '西药《药学专业知识（一）》基础入门班', teacher: '张盛妍', classHour: '2h', price: '免费', experience: '免费试听', icon: topicTeacherImgs.kecheng_shiting },
            { id: 2, title: '西药《药学专业知识（二）》基础入门班', teacher: '李小凡', classHour: '2h', price: '免费', experience: '免费试听', icon: topicTeacherImgs.kecheng_shiting },
            { id: 3, title: '西药《综合知识与技能》基础入门班', teacher: '柳洁', classHour: '2h', price: '免费', experience: '免费试听', icon: topicTeacherImgs.kecheng_shiting },
            { id: 4, title: '西药《药事管理与法规》基础入门班', teacher: '衣铖', classHour: '2h', price: '免费', experience: '免费试听', icon: topicTeacherImgs.kecheng_shiting },
          ]
        },
        {
          title: '教材精讲班', id: 2, active: false, classInfo: '梳理备考要点体系，搭建知识框架，扫除知识盲点', assortService: [
            { title: '权威题库', id: 1 },
            { title: '移动课堂', id: 2 },
            { title: '课程讲义', id: 3 },
            { title: '视频下载', id: 4 }
          ],
          validity: '12个月',
          courseList: [
            { id: 1, title: '西药《药学专业知识（一）》教材精讲班', teacher: '张盛妍', classHour: '35h', price: '￥280', experience: '免费试听', icon: topicTeacherImgs.kecheng_shiting },
            { id: 2, title: '西药《药学专业知识（二）》教材精讲班', teacher: '李小凡', classHour: '30h', price: '￥280', experience: '免费试听', icon: topicTeacherImgs.kecheng_shiting },
            { id: 3, title: '西药《综合知识与技能》教材精讲班', teacher: '柳洁', classHour: '25h', price: '￥280', experience: '免费试听', icon: topicTeacherImgs.kecheng_shiting },
            { id: 4, title: '西药《药事管理与法规》教材精讲班', teacher: '衣铖', classHour: '22h', price: '￥280', experience: '免费试听', icon: topicTeacherImgs.kecheng_shiting },
          ]
        },
        {
          title: '冲刺押题班', id: 3, active: false, classInfo: '串讲核心考点，短期快速提分', assortService: [
            { title: '权威题库', id: 1 },
            { title: '移动课堂', id: 2 },
            { title: '课程讲义', id: 3 },
            { title: '视频下载', id: 4 }
          ],
          validity: '12个月',
          courseList: [
            { id: 1, title: '西药《药学专业知识（一）》冲刺押题班', teacher: '张盛妍', classHour: '10h', price: '￥100', experience: '免费试听', icon: topicTeacherImgs.kecheng_shiting },
            { id: 2, title: '西药《药学专业知识（二）》冲刺押题班', teacher: '李小凡', classHour: '7.5h', price: '￥100', experience: '免费试听', icon: topicTeacherImgs.kecheng_shiting },
            { id: 3, title: '西药《综合知识与技能》冲刺押题班', teacher: '柳洁', classHour: '7.5h', price: '￥100', experience: '免费试听', icon: topicTeacherImgs.kecheng_shiting },
            { id: 4, title: '西药《药事管理与法规》冲刺押题班', teacher: '衣铖', classHour: '7.5h', price: '￥100', experience: '免费试听', icon: topicTeacherImgs.kecheng_shiting },
          ]
        },
        {
          title: '模拟押题班', id: 4, active: false, classInfo: '识别知识误区，避免考试落入陷阱，进入临考状态。', assortService: [
            { title: '权威题库', id: 1 },
            { title: '移动课堂', id: 2 },
            { title: '课程讲义', id: 3 },
            { title: '视频下载', id: 4 }
          ],
          validity: '12个月',
          courseList: [
            { id: 1, title: '西药《药学专业知识（一）》模拟押题班', teacher: '张盛妍', classHour: '2h', price: '￥100', experience: '免费试听', icon: topicTeacherImgs.kecheng_shiting },
            { id: 2, title: '西药《药学专业知识（二）》模拟押题班', teacher: '李小凡', classHour: '2h', price: '￥100', experience: '免费试听', icon: topicTeacherImgs.kecheng_shiting },
            { id: 3, title: '西药《综合知识与技能》模拟押题班', teacher: '柳洁', classHour: '2h', price: '￥100', experience: '免费试听', icon: topicTeacherImgs.kecheng_shiting },
            { id: 4, title: '西药《药事管理与法规》模拟押题班', teacher: '衣铖', classHour: '2h', price: '￥100', experience: '免费试听', icon: topicTeacherImgs.kecheng_shiting },
          ]
        },
        {
          title: '习题班', id: 5, active: false, classInfo: '讲解权威试题，并对知识点延伸，举一反三，学以致用。', assortService: [
            { title: '权威题库', id: 1 },
            { title: '移动课堂', id: 2 },
            { title: '课程讲义', id: 3 },
            { title: '视频下载', id: 4 }
          ],
          validity: '12个月',
          courseList: [
            { id: 1, title: '西药《药学专业知识（一）》习题班', teacher: '张盛妍', classHour: '4h', price: '￥100', experience: '免费试听', icon: topicTeacherImgs.kecheng_shiting },
            { id: 2, title: '西药《药学专业知识（二）》习题班', teacher: '李小凡', classHour: '4h', price: '￥100', experience: '免费试听', icon: topicTeacherImgs.kecheng_shiting },
            { id: 3, title: '西药《综合知识与技能》习题班', teacher: '柳洁', classHour: '4h', price: '￥100', experience: '免费试听', icon: topicTeacherImgs.kecheng_shiting },
            { id: 4, title: '西药《药事管理与法规》习题班', teacher: '衣铖', classHour: '4h', price: '￥100', experience: '免费试听', icon: topicTeacherImgs.kecheng_shiting },
          ]
        }
      ]
    }
  ]
}

//执业药师 - 考情分析
export const LicensedPharmacistCertificateData = {
  title: '考情分析',
  subtitle: '执业药师每年都会有相关政策调整，提前报考，提前拿证',
  name: 'certificate',
  totalbackImg: topicLicensedPharmacistImgs.analysis_bg,
  backgroundImg: topicLicensedPharmacistImgs.tltle_analysis,
  width: '890px',
  list: [
    { id: 1, title: '报考条件', content: '2020年执业药师考试条件审核新标准，非药学、医学、生物学等专业将不能报考，错过本次，报考将更难！' },
    { id: 2, title: '等级限制', content: '2020以后将正式加考助理药师级别考试，通过后还需从事相关行业满3年才可报考，错过本次考试，将延误三年！' },
    { id: 3, title: '题型变化', content: '新旧大纲仅有40%考点重合，选择题等题型占比分值调整，难度加大，打好基础更加重要，自学通过率将更低！' }
  ]
}

//执业药师 - 备考攻略
export const LicensedPharmacistRaidersData = {
  title: '备考攻略',
  subtitle: '三大教学进阶，全面突破重难点，轻松提分',
  name: 'raiders',
  backgroundImg: topicLicensedPharmacistImgs.tlttle_strategy,
  stageImg: topicLicensedPharmacistImgs.strategy_stage,
  width: '697px',
  list: [
    {
      id: 1, list: [
        {
          id: 1, title: '基础入门班', width: '176px', titleBack: topicLicensedPharmacistImgs.strategy_class_bg, contentList: [
            { id: 1, content: '零基础入门，帮助学生梳理学习思路及备考指导' },
            { id: 2, content: '学习课时：2-6h' }
          ]
        },
        {
          id: 2, title: '教材精讲班', width: '176px', titleBack: topicLicensedPharmacistImgs.strategy_class_bg, contentList: [
            { id: 1, content: '梳理备考要点体系，搭建知识框架，扫除知识盲点' },
            { id: 2, content: '学习课时：20-40h' }
          ]
        }
      ]
    },
    {
      id: 2, list: [
        {
          id: 1, title: '冲刺押题班/习题班', width: '236px', titleBack: topicLicensedPharmacistImgs.strategy_sceond_bg, contentList: [
            { id: 1, content: '讲解权威试题，并对知识点延伸，举一反三，学以致用' },
            { id: 2, content: '串讲核心考点，短期快速提分' },
            { id: 3, content: '学习课时：4-15h' }
          ]
        }
      ]
    },
    {
      id: 3, list: [
        {
          id: 1, title: '模拟押题班', width: '176px', titleBack: topicLicensedPharmacistImgs.strategy_class_bg, contentList: [
            { id: 1, content: '识别知识误区，避免考试落入陷阱，进入临考状态' },
            { id: 2, content: '学习课时：4-15h' }
          ]
        }
      ]
    }
  ]
}

//执业药师 - 报考指导
export const LicensedPharmacistPercentData = {
  title: '报考指导',
  subtitle: '科学的报考指导，避免备考走弯路',
  name: 'percent',
  totalbackImg: topicLicensedPharmacistImgs.guidance_bg,
  backgroundImg: topicLicensedPharmacistImgs.title_guidance,
  width: '1066px',
  height: '861px',
  subtitleImg: topicLicensedPharmacistImgs.guidance_title_bg,
  subtitleList: [
    {
      id: 1, title: '中药', direction: '医疗保健机构/中药制剂企业', diffData: [
        { id: 1, url: topicLicensedPharmacistImgs.guidance_star_solid },
        { id: 2, url: topicLicensedPharmacistImgs.guidance_star_solid },
        { id: 3, url: topicLicensedPharmacistImgs.guidance_star_solid },
        { id: 4, url: topicLicensedPharmacistImgs.guidance_star_solid },
        { id: 5, url: topicLicensedPharmacistImgs.guidance_star_hollow }
      ]
    },
    {
      id: 2, title: '西药', direction: '药店/西药生产企业', diffData: [
        { id: 1, url: topicLicensedPharmacistImgs.guidance_star_solid },
        { id: 2, url: topicLicensedPharmacistImgs.guidance_star_solid },
        { id: 3, url: topicLicensedPharmacistImgs.guidance_star_solid },
        { id: 4, url: topicLicensedPharmacistImgs.guidance_star_solid },
        { id: 5, url: topicLicensedPharmacistImgs.guidance_star_solid }
      ]
    }
  ],
  list: [
    { id: 1, title: '执业范围', subtitle: '用更短的时间，掌握更多知识点', showImg: topicFireEngineerImgs.percent_data_time, titleMask: topicFireEngineerImgs.percent_g_yellow, first_posi_title: '100%知识点掌握', second_posi_title: '20%知识点掌握' },
    { id: 2, title: '报考比例', subtitle: '用分数提高，让进步肉眼可见', showImg: topicFireEngineerImgs.percent_data_Learn, titleMask: topicFireEngineerImgs.percent_g_yellow, first_posi_title: '', second_posi_title: '' },
    { id: 3, title: '市场需求', subtitle: '用10倍通过率，给你选择的理由', showImg: topicFireEngineerImgs.percent_data_passing, titleMask: topicFireEngineerImgs.percent_g_yellow, first_posi_title: '70%通过率', second_posi_title: '7%通过率' },
  ]
}

//执业药师 - 常见问题
export const LicensedPharmacistCommonProblemData = {
  title: '常见问题',
  subtitle: '',
  name: 'common',
  backgroundImg: topicLicensedPharmacistImgs.title_problem,
  width: '415px',
  list: [
    {
      title: '课程是否为最新版？', id: 1, contentList: [
        { content: '所有课程均为新版本，每年新教材上市或大纲修订，课程将及时更新。', id: 1 }
      ]
    },
    {
      title: '课程有效期是多久？', id: 2, contentList: [
        { content: '所有课程都设置了有效期，课程不同，有效期也不同，购买时可查看课程旁有效期提醒。课程有效期都是根据考试周期进行合理设定，具体详情请查看课程介绍。', id: 1 }
      ]
    },
    {
      title: '课程有什么优惠吗？', id: 3, contentList: [
        { content: '每个用户都有优惠卷可领取，领取后在领券中心查看，可用于抵扣订单金额。', id: 1 },
        { content: '组合课程最低优惠可至一折。', id: 2 }
      ]
    },
    {
      title: '课程怎么支付？', id: 4, contentList: [
        { content: '可以使用微信、支付宝、网银在线方式支付', id: 1 },
        { content: 'PC端：打开百分网学习中心首页:<a href="http://100.wang">http://100.wang</a>，登录后点击待付款订单-去结算，提交订单-选择支付方式-支付成功。', id: 2 },
        { content: '移动端：打开百分优课小程序，点击右下角我的-登陆-点击待付款-确认付款-支付成功。', id: 3 }
      ]
    }
  ]
}

//执业药师 - 移动课堂
export const LicensedPharmacistMobileClassromData = {
  title: '移动课堂',
  subtitle: '学在掌心 / 随时随地 / 想学就学',
  tipsData: [
    { title: '实时更新，最新考点全get', id: 1 },
    { title: '所有课程购买后，均可反复观看，无二次收费', id: 2 },
    { title: '20000+丰富题库，海量资源，知识点尽在掌握', id: 3 }
  ],
  codeImg: topicTeacherImgs.sczx_code,
  leftImg: topicTeacherImgs.sczx_course_detail,
  totalbackImg: topicLicensedPharmacistImgs.mobile_bg,
  backgroundImg: topicLicensedPharmacistImgs.mobile_right_bg,
  mobile_font: topicLicensedPharmacistImgs.mobile_font,
  codeTips: '微信扫一扫，开始学习'
}
//初级会计师 - 汇总数据
export const SummaryJuniorAccountantData = [
  { title: '精品课程', id: 1, content: '1045', icon: '分钟', right_icon: '/' },
  { title: '章节练习', id: 2, content: '265', icon: '题', right_icon: '/' },
  { title: '课程数量', id: 3, content: '35', icon: '个', right_icon: '/' },
  { title: '模考套题', id: 4, content: '18', icon: '套', right_icon: '/' },
  { title: '答疑周期', id: 5, content: '24', icon: '小时', right_icon: '/' },
  { title: '满意度', id: 6, content: '100', icon: '%' },
];
// 初级会计师 - 课程体系
export const CurriculumJuniorAccountantList = {
  title: '课程体系',
  subtitle: '8年培训经验，助您轻松通过初级会计师',
  backgroundImg: topicJuniorAccountantImgs.course_bg,
  url: topicJuniorAccountantImgs.title_course,
  list: [
    {
      Name: '高端取证班',
      bgImg: topicJuniorAccountantImgs.course_class_blue,
      suitsCrowd: [
        { crowd: '零基础或新参考生' },
        { crowd: '追求课程性价比的考生' },
        { crowd: '零基础或新参考生' },
      ],
      courseContent: [
        {
          type: '全科',
          items: [{ item: '经济法基础+初级会计实务' }],
          price: 620,
          originalPrice: 1860,
        },
        {
          type: '单科',
          items: [{ item: '经济法基础' }, { item: '初级会计实务' }],
          price: 320,
          originalPrice: 960,
        },
      ],
      serviceAssurance: {
        classToEnsure: [
          { item: '报名日起2年内有效' },
          { item: '免费重学1次（考试未过可享，次年免费重学新版课程）' },
          { item: '课程有效期内笔试未过，退课程差价100元' },
          { item: '如因个人原因缺考，则不退费' },
        ],
        icon: topicJuniorAccountantImgs.course_7_blue,
      },
    },
    {
      Name: '基础套餐班',
      bgImg: topicJuniorAccountantImgs.course_class_red,
      suitsCrowd: [
        { crowd: '基础相对薄弱的新老考生' },
        { crowd: '基础突破，需要系统的辅导' },
        { crowd: '会计专业毕业，但没有工作过' },
      ],
      courseContent: [
        {
          type: '全科',
          items: [{ item: '经济法基础+初级会计实务' }],
          price: 320,
          originalPrice: 960,
        },
        {
          type: '单科',
          items: [{ item: '经济法基础' }, { item: '初级会计实务' }],
          price: 200,
          originalPrice: 600,
        },
      ],
      serviceAssurance: {
        classToEnsure: [
          { item: '报名日起2年内有效' },
          { item: '免费重学两次（考试未过可享，次年免费重学新版课程）' },
        ],
        icon: topicJuniorAccountantImgs.course_7_red,
      },
    },
    {
      Name: '教材精讲班',
      bgImg: topicJuniorAccountantImgs.course_class_red,
      suitsCrowd: [
        { crowd: '参加过会计考试的考生' },
        { crowd: '从事过会计相关工作的考生' },
        { crowd: '学习自律性强的考生' },
      ],
      courseContent: [
        {
          type: '全科',
          items: [{ item: '经济法基础+初级会计实务' }],
          price: 300,
          originalPrice: 900,
        },
      ],
      serviceAssurance: {
        classToEnsure: [{ item: '报名日起1年内有效' }],
        icon: topicJuniorAccountantImgs.course_7_purple,
      },
    },
  ],
  codeImg: topicTeacherImgs.sczx_code,
  leftImg: topicTeacherImgs.sczx_course_detail,
  totalbackImg: topicLicensedPharmacistImgs.mobile_bg,
  backgroundImg: topicLicensedPharmacistImgs.mobile_right_bg,
  mobile_font: topicLicensedPharmacistImgs.mobile_font,
  codeTips: '微信扫一扫，开始学习',
};

//自考 - 学前教育 - 汇总数据
export const SummaryPreschoolData = [
  { title: '精品课程', id: 1, content: '1633', icon: '分钟', right_icon: '/' },
  { title: '章节练习', id: 2, content: '514', icon: '题', right_icon: '/' },
  { title: '课程数量', id: 3, content: '43', icon: '个', right_icon: '/' },
  { title: '模考套题', id: 4, content: '27', icon: '套', right_icon: '/' },
  { title: '答疑周期', id: 5, content: '24', icon: '小时', right_icon: '/' },
  { title: '教学服务', id: 6, content: '720', icon: '天' },
];

//自考 - 学前教育 - 组合班级
export const PreschoolCombinClassData = {
  title: '组合班级',
  subtitle: '不同组合班级，解决你学历提升路上的"拦路虎"',
  name: 'combinClass',
  backgroundImg: selfStudyImgs.xq_title_course,
  totalbackImg: selfStudyImgs.course_bg,
  width: '983px',
  listData: [
    {
      id: 1,
      title: '单专/单本',
      active: true,
      list: [
        {
          id: 1,
          title: '取证协议班',
          vipImg: selfStudyImgs.course_class_vip,
          recommendImg: selfStudyImgs.course_hot,
          titleImg: selfStudyImgs.course_class_yesllow,
          subtitleImg: selfStudyImgs.course_g_yesllow,
          totalColor: 'yellow',
          price: 8980,
          SuitableData: [
            { id: 1, content: '零基础或新参考生' },
            { id: 2, content: '自制力差需要督促的考生' },
            { id: 3, content: '追求性价比的考生' },
          ],
          CourseContentData: [
            {
              id: 1,
              title: '导学',
              list: [{ id: 1, content: '考情考纲详解' }],
            },
            {
              id: 2,
              title: '精讲',
              list: [{ id: 1, content: '基础知识点详解' }],
            },
            {
              id: 3,
              title: '串讲',
              list: [{ id: 1, content: '重要考点串讲解' }],
            },
            {
              id: 4,
              title: '考前冲刺',
              list: [{ id: 1, content: '考前历年真题冲刺讲解（直播）' }],
            },
          ],
          CourseData: [
            { id: 1, content: '考情考纲 —— 官方考纲，梳理课程的重难点脉络' },
            { id: 2, content: '通关宝典 —— 考前资料，浓缩整科知识要点' },
            { id: 3, content: '高频考点 —— 结合历年真题，提炼高频考核点' },
          ],
          studyBankData: [
            { id: 1, title: '章节练习' },
            { id: 2, title: '历年真题' },
            { id: 3, title: '模拟考试' },
            { id: 4, title: '错题集' },
            { id: 5, title: '高频考点' },
            { id: 6, title: '预测题' },
          ],
          studyFormData: [{ id: 1, title: '视频课程+在线直播课程（可回放）' }],
          studyModeData: [
            { id: 1, content: 'PC端+手机端在线学习' },
            { id: 2, content: '系统智能辅导，针对每个考生的薄弱知识点，每日智能推荐学习内容' },
            { id: 3, content: 'PC端+错题强化，针对易题进行专项强化练习' },
          ],
          serviceData: [
            {
              id: 1,
              url: selfStudyImgs.course_fu_yesllow,
              list: [
                { id: 1, content: '论文辅导' },
                { id: 2, content: '学位英语主干高频考点讲解' },
                { id: 3, content: 'VIP学员专属内部讲义' },
                { id: 4, content: '随堂助教专业答疑' },
                { id: 5, content: '专职学管师课程规划' },
                { id: 6, content: '人性化课程延时服务' },
                { id: 7, content: '重要考试提醒服务' },
                { id: 8, content: '报名考试全程指导' },
                { id: 9, content: '全程1对1督学服务' },
                { id: 10, content: '薄弱知识专项指导' },
                { id: 11, content: '<span style="color: #d18f2d;">学士学位申办指导</span>' },
                { id: 12, content: '<span style="color: #d18f2d;">毕业证申办指导</span>' },
              ],
            },
            {
              id: 2,
              url: selfStudyImgs.course_bz_red,
              list: [
                { id: 1, content: '100%不过退费:若考试不通过，可获得协议赔付（最大100%额度）' },
                { id: 2, content: '奖学金激励' },
                { id: 3, content: '<span style="color: #f01414;">24小时无理由退换</span>' },
              ],
            },
          ],
        },
        {
          id: 2,
          title: '无忧通关班',
          vipImg: '',
          recommendImg: '',
          titleImg: selfStudyImgs.course_class_blue,
          subtitleImg: selfStudyImgs.course_g_blue,
          totalColor: 'blue',
          price: 6680,
          SuitableData: [
            { id: 1, content: '基础相对薄弱的新老考生' },
            { id: 2, content: '单科突破，想要定点辅导的考生' },
            { id: 3, content: '没时间备考，但想取得学历的考生' },
          ],
          CourseContentData: [
            {
              id: 1,
              title: '导学',
              list: [{ id: 1, content: '考情考纲详解' }],
            },
            {
              id: 2,
              title: '精讲',
              list: [{ id: 1, content: '基础知识点详解' }],
            },
            {
              id: 3,
              title: '考前冲刺',
              list: [{ id: 1, content: '考前历年真题冲刺讲解（直播）' }],
            },
          ],
          CourseData: [
            { id: 1, content: '考情考纲 —— 官方考纲，梳理课程的重难点脉络' },
            { id: 2, content: '通关宝典 —— 考前资料，浓缩整科知识要点' },
          ],
          studyBankData: [
            { id: 1, title: '章节练习' },
            { id: 2, title: '历年真题' },
            { id: 3, title: '模拟考试' },
            { id: 4, title: '错题集' },
          ],
          studyFormData: [{ id: 1, title: '视频课程+在线直播课程（可回放）' }],
          studyModeData: [
            { id: 1, content: 'PC端+手机端在线学习' },
            { id: 2, content: '系统智能辅导，针对每个考生的薄弱知识点，每日智能推荐学习内容' },
          ],
          serviceData: [
            {
              id: 1,
              url: selfStudyImgs.course_fu_blue,
              list: [
                { id: 1, content: '随堂助教专业答疑' },
                { id: 2, content: '专职学管师课程规划' },
                { id: 3, content: '重要考试提醒服务' },
                { id: 4, content: '报名考试全程指导' },
                { id: 5, content: '人性化课程延时服务' },
                { id: 6, content: '<span style="color: #d18f2d;">学士学位申办指导</span>' },
                { id: 7, content: '<span style="color: #d18f2d;">毕业证申办指导</span>' },
              ],
            },
            {
              id: 2,
              url: selfStudyImgs.course_bz_red,
              list: [{ id: 1, content: '不过退费，若考试不通过，可获得协议赔付' }],
            },
          ],
        },
        {
          id: 3,
          title: '基础套餐班',
          vipImg: '',
          recommendImg: '',
          titleImg: selfStudyImgs.course_class_green,
          subtitleImg: selfStudyImgs.course_g_green,
          totalColor: 'green',
          price: 4680,
          SuitableData: [
            { id: 1, content: '参加过考试，有考试经验的考生' },
            { id: 2, content: '学习自律性强的考生' },
          ],
          CourseContentData: [
            {
              id: 1,
              title: '精讲',
              list: [{ id: 1, content: '基础知识点详解' }],
            },
            {
              id: 2,
              title: '串讲',
              list: [{ id: 1, content: '重要考点串讲解' }],
            },
          ],
          CourseData: [{ id: 1, content: '考情考纲 —— 官方考纲，梳理课程的重难点脉络' }],
          studyBankData: [
            { id: 1, title: '章节练习' },
            { id: 2, title: '历年真题' },
            { id: 3, title: '模拟考试' },
            { id: 4, title: '错题集' },
          ],
          studyFormData: [{ id: 1, title: '视频课程' }],
          studyModeData: [
            { id: 1, content: 'PC端+手机端在线学习' },
            { id: 2, content: '系统智能辅导，针对每个考生的薄弱知识点，每日智能推荐学习内容' },
          ],
          serviceData: [
            {
              id: 1,
              url: selfStudyImgs.course_fu_green,
              list: [
                { id: 1, content: '学员入门导学' },
                { id: 2, content: '学习平台开班指导' },
                { id: 3, content: '随堂助教专业答疑' },
                { id: 4, content: '报名考试流程指导' },
              ],
            },
          ],
        },
      ],
    },
    {
      id: 2,
      title: '专本同读',
      active: false,
      list: [
        {
          id: 1,
          title: '专本尊享班',
          vipImg: selfStudyImgs.course_class_vip,
          recommendImg: selfStudyImgs.course_hot,
          titleImg: selfStudyImgs.course_class_yesllow,
          subtitleImg: selfStudyImgs.course_g_yesllow,
          totalColor: 'yellow',
          price: 15880,
          SuitableData: [
            { id: 1, content: '零基础或新参考生' },
            { id: 2, content: '自制力差需要督促的考生' },
            { id: 3, content: '追求性价比的考生' },
          ],
          CourseContentData: [
            {
              id: 1,
              title: '导学',
              list: [{ id: 1, content: '考情考纲详解' }],
            },
            {
              id: 2,
              title: '精讲',
              list: [{ id: 1, content: '基础知识点详解' }],
            },
            {
              id: 3,
              title: '串讲',
              list: [{ id: 1, content: '重要考点串讲解' }],
            },
            {
              id: 4,
              title: '考前冲刺',
              list: [{ id: 1, content: '考前历年真题冲刺讲解（直播）' }],
            },
          ],
          CourseData: [
            { id: 1, content: '考情考纲 —— 官方考纲，梳理课程的重难点脉络' },
            { id: 2, content: '通关宝典 —— 考前资料，浓缩整科知识要点' },
            { id: 3, content: '高频考点 —— 结合历年真题，提炼高频考核点' },
          ],
          studyBankData: [
            { id: 1, title: '章节练习' },
            { id: 2, title: '历年真题' },
            { id: 3, title: '模拟考试' },
            { id: 4, title: '错题集' },
            { id: 5, title: '高频考点' },
          ],
          studyFormData: [{ id: 1, title: '视频课程+在线直播课程（可回放）' }],
          studyModeData: [
            { id: 1, content: 'PC端+手机端在线学习' },
            { id: 2, content: '系统智能辅导，针对每个考生的薄弱知识点，每日智能推荐学习内容' },
            { id: 3, content: 'PC端+错题强化，针对易题进行专项强化练习' },
          ],
          serviceData: [
            {
              id: 1,
              url: selfStudyImgs.course_fu_yesllow,
              list: [
                { id: 1, content: '论文辅导' },
                { id: 2, content: '学位英语主干高频考点讲解' },
                { id: 3, content: 'VIP学员专属内部讲义' },
                { id: 4, content: '随堂助教专业答疑' },
                { id: 5, content: '专职学管师课程规划' },
                { id: 6, content: '人性化课程延时服务' },
                { id: 7, content: '重要考试提醒服务' },
                { id: 8, content: '报名考试全程指导' },
                { id: 9, content: '全程1对1督学服务' },
                { id: 10, content: '薄弱知识专项指导' },
              ],
            },
            {
              id: 2,
              url: selfStudyImgs.course_bz_red,
              list: [
                { id: 1, content: '100%不过退费:若考试不通过，可获得协议赔付（最大100%额度）' },
                { id: 2, content: '奖学金激励' },
                { id: 3, content: '<span style="color: #f01414;">24小时无理由退换</span>' },
                { id: 3, content: '<span style="color: #f01414;">支持分期付款</span>' },
              ],
            },
          ],
        },
      ],
    },
  ],
};

//自考 - 学前教育 - 课程体系
export const PreschoolCurriculumData = {
  title: '课程体系',
  subtitle: '完备课程，助力轻松考学历',
  name: 'curriculum',
  backgroundImg: selfStudyImgs.xq_title_class,
  totalbackImg: selfStudyImgs.class_bg,
  width: '545px',
  list: [
    {
      id: 1,
      serial: '01',
      code: '03708',
      name: '中国近代史纲要',
      natrue: '公共基础课',
      correspond: '/',
      sign: '必考',
      credit: 2,
      remark: '/',
    },
    {
      id: 2,
      serial: '02',
      code: '03709',
      name: '马克思主义基本原理概论',
      natrue: '公共基础课',
      correspond: '/',
      sign: '必考',
      credit: 4,
      remark: '/',
    },
    {
      id: 3,
      serial: '03',
      code: '00385',
      name: '学前卫生学',
      natrue: '专业核心课',
      correspond: '/',
      sign: '必考',
      credit: 4,
      remark: '/',
    },
    {
      id: 4,
      serial: '04',
      code: '00394',
      name: '幼儿园课程',
      natrue: '专业核心课',
      correspond: '/',
      sign: '必考',
      credit: 4,
      remark: '/',
    },
    {
      id: 5,
      serial: '05',
      code: '00398',
      name: '学前教育原理',
      natrue: '专业核心课',
      correspond: '/',
      sign: '必考',
      credit: 6,
      remark: '/',
    },
    {
      id: 6,
      serial: '06',
      code: '00882',
      name: '学前教育心理学',
      natrue: '专业核心课',
      correspond: '/',
      sign: '必考',
      credit: 6,
      remark: '/',
    },
    {
      id: 7,
      serial: '07',
      code: '03657',
      name: '学前教育研究办法',
      natrue: '专业核心课',
      correspond: '/',
      sign: '必考',
      credit: 5,
      remark: '/',
    },
    {
      id: 8,
      serial: '08',
      code: '12350',
      name: '儿童发展理论',
      natrue: '专业核心课',
      correspond: '/',
      sign: '必考',
      credit: 4,
      remark: '/',
    },
    {
      id: 9,
      serial: '09',
      code: '12657',
      name: '幼儿教师教研指导',
      natrue: '实践性环节',
      correspond: '/',
      sign: '必考',
      credit: 6,
      remark: '选考课不得低于5门、学分不得低于28学分',
      rowspan: 9,
    },
    {
      id: 10,
      serial: '10',
      code: '00015',
      name: '英语（二）',
      natrue: '选考课',
      correspond: '/',
      sign: '选考',
      credit: 14,
      remark: '',
    },
    {
      id: 11,
      serial: '11',
      code: '00387',
      name: '幼儿园组织与管理',
      natrue: '选考课',
      correspond: '/',
      sign: '选考',
      credit: 5,
      remark: '',
    },
    {
      id: 12,
      serial: '12',
      code: '00401',
      name: '学前比较教育',
      natrue: '选考课',
      correspond: '/',
      sign: '选考',
      credit: 6,
      remark: '',
    },
    {
      id: 13,
      serial: '13',
      code: '00402',
      name: '学前教育史',
      natrue: '选考课',
      correspond: '/',
      sign: '选考',
      credit: 6,
      remark: '',
    },
    {
      id: 14,
      serial: '14',
      code: '02316',
      name: '计算机应用技术',
      natrue: '选考课',
      correspond: '/',
      sign: '选考',
      credit: 2,
      remark: '',
    },
    {
      id: 15,
      serial: '15',
      code: '12351',
      name: '低幼儿童文学名著导读',
      natrue: '选考课',
      correspond: '/',
      sign: '选考',
      credit: 3,
      remark: '',
    },
    {
      id: 16,
      serial: '16',
      code: '12353',
      name: '学前儿童心理健康与辅导',
      natrue: '选考课',
      correspond: '/',
      sign: '选考',
      credit: 2,
      remark: '',
    },
    {
      id: 17,
      serial: '17',
      code: '30007',
      name: '学前儿童发展评估',
      natrue: '选考课',
      correspond: '/',
      sign: '选考',
      credit: 4,
      remark: '',
    },
    {
      id: 18,
      serial: '18',
      code: '30008',
      name: '家长工作与家园沟通',
      natrue: '选考课',
      correspond: '/',
      sign: '选考',
      credit: 2,
      remark: ' ',
    },
    {
      id: 19,
      serial: '19',
      code: '30009',
      name: '幼儿园班级管理',
      natrue: '选考课',
      correspond: '/',
      sign: '选考',
      credit: 2,
      remark: ' ',
    },
    {
      id: 20,
      serial: 'S1',
      code: '02317',
      name: '计算机应用技术（实践）',
      natrue: '实践性环节',
      correspond: '/',
      sign: '选考',
      credit: 3,
      remark: ' ',
    },
    {
      id: 21,
      serial: '20',
      code: '10224',
      name: '学前教育毕业论文',
      natrue: '实践性环节',
      correspond: '/',
      sign: '必考',
      credit: 0,
      remark: ' ',
    },
  ],
};

//自考 - 工程安全管理 - 汇总数据
export const SummaryEngineerSafetyData = [
  { title: '精品课程', id: 1, content: '1633', icon: '分钟', right_icon: '/' },
  { title: '章节练习', id: 2, content: '514', icon: '题', right_icon: '/' },
  { title: '课程数量', id: 3, content: '43', icon: '个', right_icon: '/' },
  { title: '模考套题', id: 4, content: '27', icon: '套', right_icon: '/' },
  { title: '答疑周期', id: 5, content: '24', icon: '小时', right_icon: '/' },
  { title: '教学服务', id: 6, content: '720', icon: '天' },
];

//自考 - 工程安全管理 - 组合班级
export const EngineerSafetyCombinClassData = {
  title: '组合班级',
  subtitle: '不同组合班级，解决你学历提升路上的"拦路虎"',
  name: 'combinClass',
  backgroundImg: selfStudyImgs.gc_title_course,
  totalbackImg: selfStudyImgs.course_bg,
  width: '983px',
  listData: [
    {
      id: 1,
      title: '单专/单本',
      active: true,
      list: [
        {
          id: 1,
          title: '取证协议班',
          vipImg: selfStudyImgs.course_class_vip,
          recommendImg: selfStudyImgs.course_hot,
          titleImg: selfStudyImgs.course_class_yesllow,
          subtitleImg: selfStudyImgs.course_g_yesllow,
          totalColor: 'yellow',
          price: 8980,
          SuitableData: [
            { id: 1, content: '零基础或新参考生' },
            { id: 2, content: '自制力差需要督促的考生' },
            { id: 3, content: '追求性价比的考生' },
          ],
          CourseContentData: [
            {
              id: 1,
              title: '导学',
              list: [{ id: 1, content: '考情考纲详解' }],
            },
            {
              id: 2,
              title: '精讲',
              list: [{ id: 1, content: '基础知识点详解' }],
            },
            {
              id: 3,
              title: '串讲',
              list: [{ id: 1, content: '重要考点串讲解' }],
            },
            {
              id: 4,
              title: '考前冲刺',
              list: [{ id: 1, content: '考前历年真题冲刺讲解（直播）' }],
            },
          ],
          CourseData: [
            { id: 1, content: '考情考纲 —— 官方考纲，梳理课程的重难点脉络' },
            { id: 2, content: '通关宝典 —— 考前资料，浓缩整科知识要点' },
            { id: 3, content: '高频考点 —— 结合历年真题，提炼高频考核点' },
          ],
          studyBankData: [
            { id: 1, title: '章节练习' },
            { id: 2, title: '历年真题' },
            { id: 3, title: '模拟考试' },
            { id: 4, title: '错题集' },
            { id: 5, title: '高频考点' },
            { id: 6, title: '预测题' },
          ],
          studyFormData: [{ id: 1, title: '视频课程+在线直播课程（可回放）' }],
          studyModeData: [
            { id: 1, content: 'PC端+手机端在线学习' },
            { id: 2, content: '系统智能辅导，针对每个考生的薄弱知识点，每日智能推荐学习内容' },
            { id: 3, content: 'PC端+错题强化，针对易题进行专项强化练习' },
          ],
          serviceData: [
            {
              id: 1,
              url: selfStudyImgs.course_fu_yesllow,
              list: [
                { id: 1, content: '论文辅导' },
                { id: 2, content: '学位英语主干高频考点讲解' },
                { id: 3, content: 'VIP学员专属内部讲义' },
                { id: 4, content: '随堂助教专业答疑' },
                { id: 5, content: '专职学管师课程规划' },
                { id: 6, content: '人性化课程延时服务' },
                { id: 7, content: '重要考试提醒服务' },
                { id: 8, content: '报名考试全程指导' },
                { id: 9, content: '全程1对1督学服务' },
                { id: 10, content: '薄弱知识专项指导' },
                { id: 11, content: '<span style="color: #d18f2d;">学士学位申办指导</span>' },
                { id: 12, content: '<span style="color: #d18f2d;">毕业证申办指导</span>' },
              ],
            },
            {
              id: 2,
              url: selfStudyImgs.course_bz_red,
              list: [
                { id: 1, content: '100%不过退费:若考试不通过，可获得协议赔付（最大100%额度）' },
                { id: 2, content: '奖学金激励' },
                { id: 3, content: '<span style="color: #f01414;">24小时无理由退换</span>' },
              ],
            },
          ],
        },
        {
          id: 2,
          title: '无忧通关班',
          vipImg: '',
          recommendImg: '',
          titleImg: selfStudyImgs.course_class_blue,
          subtitleImg: selfStudyImgs.course_g_blue,
          totalColor: 'blue',
          price: 6680,
          SuitableData: [
            { id: 1, content: '基础相对薄弱的新老考生' },
            { id: 2, content: '单科突破，想要定点辅导的考生' },
            { id: 3, content: '没时间备考，但想取得学历的考生' },
          ],
          CourseContentData: [
            {
              id: 1,
              title: '导学',
              list: [{ id: 1, content: '考情考纲详解' }],
            },
            {
              id: 2,
              title: '精讲',
              list: [{ id: 1, content: '基础知识点详解' }],
            },
            {
              id: 3,
              title: '考前冲刺',
              list: [{ id: 1, content: '考前历年真题冲刺讲解（直播）' }],
            },
          ],
          CourseData: [
            { id: 1, content: '考情考纲 —— 官方考纲，梳理课程的重难点脉络' },
            { id: 2, content: '通关宝典 —— 考前资料，浓缩整科知识要点' },
          ],
          studyBankData: [
            { id: 1, title: '章节练习' },
            { id: 2, title: '历年真题' },
            { id: 3, title: '模拟考试' },
            { id: 4, title: '错题集' },
          ],
          studyFormData: [{ id: 1, title: '视频课程+在线直播课程（可回放）' }],
          studyModeData: [
            { id: 1, content: 'PC端+手机端在线学习' },
            { id: 2, content: '系统智能辅导，针对每个考生的薄弱知识点，每日智能推荐学习内容' },
          ],
          serviceData: [
            {
              id: 1,
              url: selfStudyImgs.course_fu_blue,
              list: [
                { id: 1, content: '随堂助教专业答疑' },
                { id: 2, content: '专职学管师课程规划' },
                { id: 3, content: '重要考试提醒服务' },
                { id: 4, content: '报名考试全程指导' },
                { id: 5, content: '人性化课程延时服务' },
                { id: 6, content: '<span style="color: #d18f2d;">学士学位申办指导</span>' },
                { id: 7, content: '<span style="color: #d18f2d;">毕业证申办指导</span>' },
              ],
            },
            {
              id: 2,
              url: selfStudyImgs.course_bz_red,
              list: [{ id: 1, content: '不过退费，若考试不通过，可获得协议赔付' }],
            },
          ],
        },
        {
          id: 3,
          title: '基础套餐班',
          vipImg: '',
          recommendImg: '',
          titleImg: selfStudyImgs.course_class_green,
          subtitleImg: selfStudyImgs.course_g_green,
          totalColor: 'green',
          price: 4680,
          SuitableData: [
            { id: 1, content: '参加过考试，有考试经验的考生' },
            { id: 2, content: '学习自律性强的考生' },
          ],
          CourseContentData: [
            {
              id: 1,
              title: '精讲',
              list: [{ id: 1, content: '基础知识点详解' }],
            },
            {
              id: 2,
              title: '串讲',
              list: [{ id: 1, content: '重要考点串讲解' }],
            },
          ],
          CourseData: [{ id: 1, content: '考情考纲 —— 官方考纲，梳理课程的重难点脉络' }],
          studyBankData: [
            { id: 1, title: '章节练习' },
            { id: 2, title: '历年真题' },
            { id: 3, title: '模拟考试' },
            { id: 4, title: '错题集' },
          ],
          studyFormData: [{ id: 1, title: '视频课程' }],
          studyModeData: [
            { id: 1, content: 'PC端+手机端在线学习' },
            { id: 2, content: '系统智能辅导，针对每个考生的薄弱知识点，每日智能推荐学习内容' },
          ],
          serviceData: [
            {
              id: 1,
              url: selfStudyImgs.course_fu_green,
              list: [
                { id: 1, content: '学员入门导学' },
                { id: 2, content: '学习平台开班指导' },
                { id: 3, content: '随堂助教专业答疑' },
                { id: 4, content: '报名考试流程指导' },
              ],
            },
          ],
        },
      ],
    },
    {
      id: 2,
      title: '专本同读',
      active: false,
      list: [
        {
          id: 1,
          title: '专本尊享班',
          vipImg: selfStudyImgs.course_class_vip,
          recommendImg: selfStudyImgs.course_hot,
          titleImg: selfStudyImgs.course_class_yesllow,
          subtitleImg: selfStudyImgs.course_g_yesllow,
          totalColor: 'yellow',
          price: 15880,
          SuitableData: [
            { id: 1, content: '零基础或新参考生' },
            { id: 2, content: '自制力差需要督促的考生' },
            { id: 3, content: '追求性价比的考生' },
          ],
          CourseContentData: [
            {
              id: 1,
              title: '导学',
              list: [{ id: 1, content: '考情考纲详解' }],
            },
            {
              id: 2,
              title: '精讲',
              list: [{ id: 1, content: '基础知识点详解' }],
            },
            {
              id: 3,
              title: '串讲',
              list: [{ id: 1, content: '重要考点串讲解' }],
            },
            {
              id: 4,
              title: '考前冲刺',
              list: [{ id: 1, content: '考前历年真题冲刺讲解（直播）' }],
            },
          ],
          CourseData: [
            { id: 1, content: '考情考纲 —— 官方考纲，梳理课程的重难点脉络' },
            { id: 2, content: '通关宝典 —— 考前资料，浓缩整科知识要点' },
            { id: 3, content: '高频考点 —— 结合历年真题，提炼高频考核点' },
          ],
          studyBankData: [
            { id: 1, title: '章节练习' },
            { id: 2, title: '历年真题' },
            { id: 3, title: '模拟考试' },
            { id: 4, title: '错题集' },
            { id: 5, title: '高频考点' },
          ],
          studyFormData: [{ id: 1, title: '视频课程+在线直播课程（可回放）' }],
          studyModeData: [
            { id: 1, content: 'PC端+手机端在线学习' },
            { id: 2, content: '系统智能辅导，针对每个考生的薄弱知识点，每日智能推荐学习内容' },
            { id: 3, content: 'PC端+错题强化，针对易题进行专项强化练习' },
          ],
          serviceData: [
            {
              id: 1,
              url: selfStudyImgs.course_fu_yesllow,
              list: [
                { id: 1, content: '论文辅导' },
                { id: 2, content: '学位英语主干高频考点讲解' },
                { id: 3, content: 'VIP学员专属内部讲义' },
                { id: 4, content: '随堂助教专业答疑' },
                { id: 5, content: '专职学管师课程规划' },
                { id: 6, content: '人性化课程延时服务' },
                { id: 7, content: '重要考试提醒服务' },
                { id: 8, content: '报名考试全程指导' },
                { id: 9, content: '全程1对1督学服务' },
                { id: 10, content: '薄弱知识专项指导' },
              ],
            },
            {
              id: 2,
              url: selfStudyImgs.course_bz_red,
              list: [
                { id: 1, content: '100%不过退费:若考试不通过，可获得协议赔付（最大100%额度）' },
                { id: 2, content: '奖学金激励' },
                { id: 3, content: '<span style="color: #f01414;">24小时无理由退换</span>' },
                { id: 3, content: '<span style="color: #f01414;">支持分期付款</span>' },
              ],
            },
          ],
        },
      ],
    },
  ],
};

//自考 - 工程安全管理 - 课程体系
export const EngineerSafetyCurriculumData = {
  title: '课程体系',
  subtitle: '完备课程，助力轻松考学历',
  name: 'curriculum',
  backgroundImg: selfStudyImgs.gc_title_class,
  totalbackImg: selfStudyImgs.class_bg,
  width: '545px',
  list: [
    {
      id: 1,
      serial: '01',
      code: '03708',
      name: '中国近代史纲要',
      natrue: '公共基础课',
      correspond: '/',
      sign: '必考',
      credit: 2,
      remark: '/',
    },
    {
      id: 2,
      serial: '02',
      code: '03709',
      name: '马克思主义基本原理概论',
      natrue: '公共基础课',
      correspond: '/',
      sign: '必考',
      credit: 4,
      remark: '/',
    },
    {
      id: 3,
      serial: '03',
      code: '12146',
      name: '安全学原理',
      natrue: '专业核心课',
      correspond: '/',
      sign: '必考',
      credit: 5,
      remark: '/',
    },
    {
      id: 4,
      serial: '04',
      code: '12147',
      name: '安全管理信息系统',
      natrue: '专业核心课',
      correspond: '/',
      sign: '必考',
      credit: 5,
      remark: '/',
    },
    {
      id: 5,
      serial: '05',
      code: '12148',
      name: '防火与防暴技术',
      natrue: '专业核心课',
      correspond: '/',
      sign: '必考',
      credit: 5,
      remark: '/',
    },
    {
      id: 6,
      serial: '06',
      code: '12149',
      name: '安全评价理论与技术',
      natrue: '专业核心课',
      correspond: '/',
      sign: '必考',
      credit: 5,
      remark: '/',
    },
    {
      id: 7,
      serial: '07',
      code: '12150',
      name: '安全经济学',
      natrue: '专业核心课',
      correspond: '/',
      sign: '必考',
      credit: 4,
      remark: '/',
    },
    {
      id: 8,
      serial: '08',
      code: '12151',
      name: '安全检测技术',
      natrue: '专业核心课',
      correspond: '/',
      sign: '必考',
      credit: 4,
      remark: '/',
    },
    {
      id: 9,
      serial: '09',
      code: '12152',
      name: '建筑工程安全生产法律法规',
      natrue: '专业核心课',
      correspond: '/',
      sign: '必考',
      credit: 4,
      remark: '/',
    },
    {
      id: 10,
      serial: '10',
      code: '00015',
      name: '英语（二）',
      natrue: '选考课',
      correspond: '/',
      sign: '选考',
      credit: 14,
      remark: '选考课不得低于4门、学分不得低于30学分',
      rowspan: 12,
    },
    {
      id: 11,
      serial: '11',
      code: '00023',
      name: '高等数学（工本）',
      natrue: '选考课',
      correspond: '/',
      sign: '选考',
      credit: 10,
      remark: '',
    },
    {
      id: 12,
      serial: '12',
      code: '00153',
      name: '质量管理（一）',
      natrue: '选考课',
      correspond: '/',
      sign: '选考',
      credit: 4,
      remark: '',
    },
    {
      id: 13,
      serial: '13',
      code: '02194',
      name: '工程经济',
      natrue: '选考课',
      correspond: '/',
      sign: '选考',
      credit: 4,
      remark: '',
    },
    {
      id: 14,
      serial: '14',
      code: '03453',
      name: '创业学',
      natrue: '选考课',
      correspond: '/',
      sign: '选考',
      credit: 6,
      remark: '',
    },
    {
      id: 15,
      serial: '15',
      code: '12351',
      name: '概率论与数理统计（经管类）',
      natrue: '选考课',
      correspond: '/',
      sign: '选考',
      credit: 5,
      remark: '',
    },
    {
      id: 16,
      serial: '16',
      code: '04184',
      name: '线性代数（经管类）',
      natrue: '选考课',
      correspond: '/',
      sign: '选考',
      credit: 4,
      remark: '',
    },
    {
      id: 17,
      serial: '17',
      code: '06086',
      name: '工程监理',
      natrue: '选考课',
      correspond: '/',
      sign: '选考',
      credit: 5,
      remark: '',
    },
    {
      id: 18,
      serial: '18',
      code: '12153',
      name: '矿山工程安全技术',
      natrue: '选考课',
      correspond: '/',
      sign: '选考',
      credit: 5,
      remark: '',
    },
    {
      id: 19,
      serial: '19',
      code: '12154',
      name: '建筑工程安全技术',
      natrue: '选考课',
      correspond: '/',
      sign: '选考',
      credit: 5,
      remark: '',
    },
    {
      id: 20,
      serial: '20',
      code: '12155',
      name: '工程安全管理生产实习（一）',
      natrue: '实践性环节',
      correspond: '/',
      sign: '选考',
      credit: 3,
      remark: '',
    },
    {
      id: 21,
      serial: '20',
      code: '12156',
      name: '工程安全管理毕业论文',
      natrue: '实践性环节',
      correspond: '/',
      sign: '必考',
      credit: 0,
      remark: '',
    },
  ],
};

//自考 - 工商企业管理 - 汇总数据
export const SummaryBusinessData = [
  { title: '精品课程', id: 1, content: '1633', icon: '分钟', right_icon: '/' },
  { title: '章节练习', id: 2, content: '514', icon: '题', right_icon: '/' },
  { title: '课程数量', id: 3, content: '43', icon: '个', right_icon: '/' },
  { title: '模考套题', id: 4, content: '27', icon: '套', right_icon: '/' },
  { title: '答疑周期', id: 5, content: '24', icon: '小时', right_icon: '/' },
  { title: '教学服务', id: 6, content: '720', icon: '天' },
];

//自考 - 工商企业管理 - 组合班级
export const BusinessCombinClassData = {
  title: '组合班级',
  subtitle: '不同组合班级，解决你学历提升路上的"拦路虎"',
  name: 'combinClass',
  backgroundImg: selfStudyImgs.gs_title_course,
  totalbackImg: selfStudyImgs.course_bg,
  width: '983px',
  listData: [
    {
      id: 1,
      title: '单专/单本',
      active: true,
      list: [
        {
          id: 1,
          title: '取证协议班',
          vipImg: selfStudyImgs.course_class_vip,
          recommendImg: selfStudyImgs.course_hot,
          titleImg: selfStudyImgs.course_class_yesllow,
          subtitleImg: selfStudyImgs.course_g_yesllow,
          totalColor: 'yellow',
          price: 8980,
          SuitableData: [
            { id: 1, content: '零基础或新参考生' },
            { id: 2, content: '自制力差需要督促的考生' },
            { id: 3, content: '追求性价比的考生' },
          ],
          CourseContentData: [
            {
              id: 1,
              title: '导学',
              list: [{ id: 1, content: '考情考纲详解' }],
            },
            {
              id: 2,
              title: '精讲',
              list: [{ id: 1, content: '基础知识点详解' }],
            },
            {
              id: 3,
              title: '串讲',
              list: [{ id: 1, content: '重要考点串讲解' }],
            },
            {
              id: 4,
              title: '考前冲刺',
              list: [{ id: 1, content: '考前历年真题冲刺讲解（直播）' }],
            },
          ],
          CourseData: [
            { id: 1, content: '考情考纲 —— 官方考纲，梳理课程的重难点脉络' },
            { id: 2, content: '通关宝典 —— 考前资料，浓缩整科知识要点' },
            { id: 3, content: '高频考点 —— 结合历年真题，提炼高频考核点' },
          ],
          studyBankData: [
            { id: 1, title: '章节练习' },
            { id: 2, title: '历年真题' },
            { id: 3, title: '模拟考试' },
            { id: 4, title: '错题集' },
            { id: 5, title: '高频考点' },
            { id: 6, title: '预测题' },
          ],
          studyFormData: [{ id: 1, title: '视频课程+在线直播课程（可回放）' }],
          studyModeData: [
            { id: 1, content: 'PC端+手机端在线学习' },
            { id: 2, content: '系统智能辅导，针对每个考生的薄弱知识点，每日智能推荐学习内容' },
            { id: 3, content: 'PC端+错题强化，针对易题进行专项强化练习' },
          ],
          serviceData: [
            {
              id: 1,
              url: selfStudyImgs.course_fu_yesllow,
              list: [
                { id: 1, content: '论文辅导' },
                { id: 2, content: '学位英语主干高频考点讲解' },
                { id: 3, content: 'VIP学员专属内部讲义' },
                { id: 4, content: '随堂助教专业答疑' },
                { id: 5, content: '专职学管师课程规划' },
                { id: 6, content: '人性化课程延时服务' },
                { id: 7, content: '重要考试提醒服务' },
                { id: 8, content: '报名考试全程指导' },
                { id: 9, content: '全程1对1督学服务' },
                { id: 10, content: '薄弱知识专项指导' },
                { id: 11, content: '<span style="color: #d18f2d;">学士学位申办指导</span>' },
                { id: 12, content: '<span style="color: #d18f2d;">毕业证申办指导</span>' },
              ],
            },
            {
              id: 2,
              url: selfStudyImgs.course_bz_red,
              list: [
                { id: 1, content: '100%不过退费:若考试不通过，可获得协议赔付（最大100%额度）' },
                { id: 2, content: '奖学金激励' },
                { id: 3, content: '<span style="color: #f01414;">24小时无理由退换</span>' },
              ],
            },
          ],
        },
        {
          id: 2,
          title: '无忧通关班',
          vipImg: '',
          recommendImg: '',
          titleImg: selfStudyImgs.course_class_blue,
          subtitleImg: selfStudyImgs.course_g_blue,
          totalColor: 'blue',
          price: 6680,
          SuitableData: [
            { id: 1, content: '基础相对薄弱的新老考生' },
            { id: 2, content: '单科突破，想要定点辅导的考生' },
            { id: 3, content: '没时间备考，但想取得学历的考生' },
          ],
          CourseContentData: [
            {
              id: 1,
              title: '导学',
              list: [{ id: 1, content: '考情考纲详解' }],
            },
            {
              id: 2,
              title: '精讲',
              list: [{ id: 1, content: '基础知识点详解' }],
            },
            {
              id: 3,
              title: '考前冲刺',
              list: [{ id: 1, content: '考前历年真题冲刺讲解（直播）' }],
            },
          ],
          CourseData: [
            { id: 1, content: '考情考纲 —— 官方考纲，梳理课程的重难点脉络' },
            { id: 2, content: '通关宝典 —— 考前资料，浓缩整科知识要点' },
          ],
          studyBankData: [
            { id: 1, title: '章节练习' },
            { id: 2, title: '历年真题' },
            { id: 3, title: '模拟考试' },
            { id: 4, title: '错题集' },
          ],
          studyFormData: [{ id: 1, title: '视频课程+在线直播课程（可回放）' }],
          studyModeData: [
            { id: 1, content: 'PC端+手机端在线学习' },
            { id: 2, content: '系统智能辅导，针对每个考生的薄弱知识点，每日智能推荐学习内容' },
          ],
          serviceData: [
            {
              id: 1,
              url: selfStudyImgs.course_fu_blue,
              list: [
                { id: 1, content: '随堂助教专业答疑' },
                { id: 2, content: '专职学管师课程规划' },
                { id: 3, content: '重要考试提醒服务' },
                { id: 4, content: '报名考试全程指导' },
                { id: 5, content: '人性化课程延时服务' },
                { id: 6, content: '<span style="color: #d18f2d;">学士学位申办指导</span>' },
                { id: 7, content: '<span style="color: #d18f2d;">毕业证申办指导</span>' },
              ],
            },
            {
              id: 2,
              url: selfStudyImgs.course_bz_red,
              list: [{ id: 1, content: '不过退费，若考试不通过，可获得协议赔付' }],
            },
          ],
        },
        {
          id: 3,
          title: '基础套餐班',
          vipImg: '',
          recommendImg: '',
          titleImg: selfStudyImgs.course_class_green,
          subtitleImg: selfStudyImgs.course_g_green,
          totalColor: 'green',
          price: 4680,
          SuitableData: [
            { id: 1, content: '参加过考试，有考试经验的考生' },
            { id: 2, content: '学习自律性强的考生' },
          ],
          CourseContentData: [
            {
              id: 1,
              title: '精讲',
              list: [{ id: 1, content: '基础知识点详解' }],
            },
            {
              id: 2,
              title: '串讲',
              list: [{ id: 1, content: '重要考点串讲解' }],
            },
          ],
          CourseData: [{ id: 1, content: '考情考纲 —— 官方考纲，梳理课程的重难点脉络' }],
          studyBankData: [
            { id: 1, title: '章节练习' },
            { id: 2, title: '历年真题' },
            { id: 3, title: '模拟考试' },
            { id: 4, title: '错题集' },
          ],
          studyFormData: [{ id: 1, title: '视频课程' }],
          studyModeData: [
            { id: 1, content: 'PC端+手机端在线学习' },
            { id: 2, content: '系统智能辅导，针对每个考生的薄弱知识点，每日智能推荐学习内容' },
          ],
          serviceData: [
            {
              id: 1,
              url: selfStudyImgs.course_fu_green,
              list: [
                { id: 1, content: '学员入门导学' },
                { id: 2, content: '学习平台开班指导' },
                { id: 3, content: '随堂助教专业答疑' },
                { id: 4, content: '报名考试流程指导' },
              ],
            },
          ],
        },
      ],
    },
    {
      id: 2,
      title: '专本同读',
      active: false,
      list: [
        {
          id: 1,
          title: '专本尊享班',
          vipImg: selfStudyImgs.course_class_vip,
          recommendImg: selfStudyImgs.course_hot,
          titleImg: selfStudyImgs.course_class_yesllow,
          subtitleImg: selfStudyImgs.course_g_yesllow,
          totalColor: 'yellow',
          price: 15880,
          SuitableData: [
            { id: 1, content: '零基础或新参考生' },
            { id: 2, content: '自制力差需要督促的考生' },
            { id: 3, content: '追求性价比的考生' },
          ],
          CourseContentData: [
            {
              id: 1,
              title: '导学',
              list: [{ id: 1, content: '考情考纲详解' }],
            },
            {
              id: 2,
              title: '精讲',
              list: [{ id: 1, content: '基础知识点详解' }],
            },
            {
              id: 3,
              title: '串讲',
              list: [{ id: 1, content: '重要考点串讲解' }],
            },
            {
              id: 4,
              title: '考前冲刺',
              list: [{ id: 1, content: '考前历年真题冲刺讲解（直播）' }],
            },
          ],
          CourseData: [
            { id: 1, content: '考情考纲 —— 官方考纲，梳理课程的重难点脉络' },
            { id: 2, content: '通关宝典 —— 考前资料，浓缩整科知识要点' },
            { id: 3, content: '高频考点 —— 结合历年真题，提炼高频考核点' },
          ],
          studyBankData: [
            { id: 1, title: '章节练习' },
            { id: 2, title: '历年真题' },
            { id: 3, title: '模拟考试' },
            { id: 4, title: '错题集' },
            { id: 5, title: '高频考点' },
          ],
          studyFormData: [{ id: 1, title: '视频课程+在线直播课程（可回放）' }],
          studyModeData: [
            { id: 1, content: 'PC端+手机端在线学习' },
            { id: 2, content: '系统智能辅导，针对每个考生的薄弱知识点，每日智能推荐学习内容' },
            { id: 3, content: 'PC端+错题强化，针对易题进行专项强化练习' },
          ],
          serviceData: [
            {
              id: 1,
              url: selfStudyImgs.course_fu_yesllow,
              list: [
                { id: 1, content: '论文辅导' },
                { id: 2, content: '学位英语主干高频考点讲解' },
                { id: 3, content: 'VIP学员专属内部讲义' },
                { id: 4, content: '随堂助教专业答疑' },
                { id: 5, content: '专职学管师课程规划' },
                { id: 6, content: '人性化课程延时服务' },
                { id: 7, content: '重要考试提醒服务' },
                { id: 8, content: '报名考试全程指导' },
                { id: 9, content: '全程1对1督学服务' },
                { id: 10, content: '薄弱知识专项指导' },
              ],
            },
            {
              id: 2,
              url: selfStudyImgs.course_bz_red,
              list: [
                { id: 1, content: '100%不过退费:若考试不通过，可获得协议赔付（最大100%额度）' },
                { id: 2, content: '奖学金激励' },
                { id: 3, content: '<span style="color: #f01414;">24小时无理由退换</span>' },
                { id: 3, content: '<span style="color: #f01414;">支持分期付款</span>' },
              ],
            },
          ],
        },
      ],
    },
  ],
};

//自考 - 工商企业管理 - 课程体系
export const BusinessCurriculumData = {
  title: '课程体系',
  subtitle: '完备课程，助力轻松考学历',
  name: 'curriculum',
  backgroundImg: selfStudyImgs.gs_title_class,
  totalbackImg: selfStudyImgs.class_bg,
  width: '545px',
  list: [
    {
      id: 1,
      serial: '01',
      code: '03708',
      name: '中国近代史纲要',
      natrue: '公共基础课',
      correspond: '/',
      sign: '必考',
      credit: 2,
      remark: '/',
    },
    {
      id: 2,
      serial: '02',
      code: '03709',
      name: '马克思主义基本原理概论',
      natrue: '公共基础课',
      correspond: '/',
      sign: '必考',
      credit: 4,
      remark: '/',
    },
    {
      id: 3,
      serial: '03',
      code: '00054',
      name: '管理学原理',
      natrue: '专业核心课',
      correspond: '/',
      sign: '必考',
      credit: 6,
      remark: '/',
    },
    {
      id: 4,
      serial: '04',
      code: '00149',
      name: '国际贸易理论与实务',
      natrue: '专业核心课',
      correspond: '/',
      sign: '必考',
      credit: 6,
      remark: '/',
    },
    {
      id: 5,
      serial: '05',
      code: '00150',
      name: '金融理论与实务',
      natrue: '专业核心课',
      correspond: '/',
      sign: '必考',
      credit: 6,
      remark: '/',
    },
    {
      id: 6,
      serial: '06',
      code: '00151',
      name: '企业经营战略',
      natrue: '专业核心课',
      correspond: '/',
      sign: '必考',
      credit: 4,
      remark: '/',
    },
    {
      id: 7,
      serial: '07',
      code: '00152',
      name: '组织行为学',
      natrue: '专业核心课',
      correspond: '/',
      sign: '必考',
      credit: 4,
      remark: '/',
    },
    {
      id: 8,
      serial: '08',
      code: '00153',
      name: '质量管理（一）',
      natrue: '专业核心课',
      correspond: '/',
      sign: '必考',
      credit: 6,
      remark: '/',
    },
    {
      id: 9,
      serial: '09',
      code: '11465',
      name: '现代公司管理',
      natrue: '专业核心课',
      correspond: '/',
      sign: '必考',
      credit: 14,
      remark: '/',
    },
    {
      id: 10,
      serial: '10',
      code: '00009',
      name: '英语（二）',
      natrue: '选考课',
      correspond: '/',
      sign: '选考',
      credit: 6,
      remark: '选考课不得低于4门、学分不得低于28学分',
      rowspan: 12,
    },
    {
      id: 11,
      serial: '11',
      code: '00045',
      name: '企业经济统计学',
      natrue: '选考课',
      correspond: '/',
      sign: '选考',
      credit: 3,
      remark: '',
    },
    {
      id: 12,
      serial: '12',
      code: '00051',
      name: '管理系统中计算机应用',
      natrue: '选考课',
      correspond: '/',
      sign: '选考',
      credit: 6,
      remark: '',
    },
    {
      id: 13,
      serial: '13',
      code: '00067',
      name: '财务管理学',
      natrue: '选考课',
      correspond: '/',
      sign: '选考',
      credit: 6,
      remark: '',
    },
    {
      id: 14,
      serial: '14',
      code: '00910',
      name: '网络经济与企业管理',
      natrue: '选考课',
      correspond: '/',
      sign: '选考',
      credit: 6,
      remark: '',
    },
    {
      id: 15,
      serial: '15',
      code: '03453',
      name: '创业学',
      natrue: '选考课',
      correspond: '/',
      sign: '选考',
      credit: 6,
      remark: '',
    },
    {
      id: 16,
      serial: '16',
      code: '04183',
      name: '概率论与数理统计（经管类）',
      natrue: '选考课',
      correspond: '/',
      sign: '选考',
      credit: 5,
      remark: '',
    },
    {
      id: 17,
      serial: '17',
      code: '04184',
      name: '线性代数（经管类）',
      natrue: '选考课',
      correspond: '/',
      sign: '选考',
      credit: 4,
      remark: '',
    },
    {
      id: 18,
      serial: '18',
      code: '07945',
      name: '企业与公司法学',
      natrue: '选考课',
      correspond: '/',
      sign: '选考',
      credit: 7,
      remark: '',
    },
    {
      id: 19,
      serial: '19',
      code: '10511',
      name: '销售团队管理',
      natrue: '选考课',
      correspond: '/',
      sign: '选考',
      credit: 6,
      remark: '',
    },
    {
      id: 20,
      serial: 'S1',
      code: '00052',
      name: '管理系统中计算机应用（实践）',
      natrue: '实践性环节',
      correspond: '00051-管理系统中计算机应用',
      sign: '选考',
      credit: 1,
      remark: '',
    },
    {
      id: 21,
      serial: '20',
      code: '10212',
      name: '工商企业管理毕业论文',
      natrue: '实践性环节',
      correspond: '/',
      sign: '必考',
      credit: 0,
      remark: '',
    },
  ],
};

//自考 - 药学 - 汇总数据
export const SummaryPharmacyData = [
  { title: '精品课程', id: 1, content: '1633', icon: '分钟', right_icon: '/' },
  { title: '章节练习', id: 2, content: '514', icon: '题', right_icon: '/' },
  { title: '课程数量', id: 3, content: '43', icon: '个', right_icon: '/' },
  { title: '模考套题', id: 4, content: '27', icon: '套', right_icon: '/' },
  { title: '答疑周期', id: 5, content: '24', icon: '小时', right_icon: '/' },
  { title: '教学服务', id: 6, content: '720', icon: '天' },
];

//自考 - 药学 - 组合班级
export const PharmacyCombinClassData = {
  title: '组合班级',
  subtitle: '不同组合班级，解决你学历提升路上的"拦路虎"',
  name: 'combinClass',
  backgroundImg: selfStudyImgs.yx_title_course,
  totalbackImg: selfStudyImgs.course_bg,
  width: '983px',
  listData: [
    {
      id: 1,
      title: '单专/单本',
      active: true,
      list: [
        {
          id: 1,
          title: '取证协议班',
          vipImg: selfStudyImgs.course_class_vip,
          recommendImg: selfStudyImgs.course_hot,
          titleImg: selfStudyImgs.course_class_yesllow,
          subtitleImg: selfStudyImgs.course_g_yesllow,
          totalColor: 'yellow',
          price: 8980,
          SuitableData: [
            { id: 1, content: '零基础或新参考生' },
            { id: 2, content: '自制力差需要督促的考生' },
            { id: 3, content: '追求性价比的考生' },
          ],
          CourseContentData: [
            {
              id: 1,
              title: '导学',
              list: [{ id: 1, content: '考情考纲详解' }],
            },
            {
              id: 2,
              title: '精讲',
              list: [{ id: 1, content: '基础知识点详解' }],
            },
            {
              id: 3,
              title: '串讲',
              list: [{ id: 1, content: '重要考点串讲解' }],
            },
            {
              id: 4,
              title: '考前冲刺',
              list: [{ id: 1, content: '考前历年真题冲刺讲解（直播）' }],
            },
          ],
          CourseData: [
            { id: 1, content: '考情考纲 —— 官方考纲，梳理课程的重难点脉络' },
            { id: 2, content: '通关宝典 —— 考前资料，浓缩整科知识要点' },
            { id: 3, content: '高频考点 —— 结合历年真题，提炼高频考核点' },
          ],
          studyBankData: [
            { id: 1, title: '章节练习' },
            { id: 2, title: '历年真题' },
            { id: 3, title: '模拟考试' },
            { id: 4, title: '错题集' },
            { id: 5, title: '高频考点' },
            { id: 6, title: '预测题' },
          ],
          studyFormData: [{ id: 1, title: '视频课程+在线直播课程（可回放）' }],
          studyModeData: [
            { id: 1, content: 'PC端+手机端在线学习' },
            { id: 2, content: '系统智能辅导，针对每个考生的薄弱知识点，每日智能推荐学习内容' },
            { id: 3, content: 'PC端+错题强化，针对易题进行专项强化练习' },
          ],
          serviceData: [
            {
              id: 1,
              url: selfStudyImgs.course_fu_yesllow,
              list: [
                { id: 1, content: '论文辅导' },
                { id: 2, content: '学位英语主干高频考点讲解' },
                { id: 3, content: 'VIP学员专属内部讲义' },
                { id: 4, content: '随堂助教专业答疑' },
                { id: 5, content: '专职学管师课程规划' },
                { id: 6, content: '人性化课程延时服务' },
                { id: 7, content: '重要考试提醒服务' },
                { id: 8, content: '报名考试全程指导' },
                { id: 9, content: '全程1对1督学服务' },
                { id: 10, content: '薄弱知识专项指导' },
                { id: 11, content: '<span style="color: #d18f2d;">学士学位申办指导</span>' },
                { id: 12, content: '<span style="color: #d18f2d;">毕业证申办指导</span>' },
              ],
            },
            {
              id: 2,
              url: selfStudyImgs.course_bz_red,
              list: [
                { id: 1, content: '100%不过退费:若考试不通过，可获得协议赔付（最大100%额度）' },
                { id: 2, content: '奖学金激励' },
                { id: 3, content: '<span style="color: #f01414;">24小时无理由退换</span>' },
              ],
            },
          ],
        },
        {
          id: 2,
          title: '无忧通关班',
          vipImg: '',
          recommendImg: '',
          titleImg: selfStudyImgs.course_class_blue,
          subtitleImg: selfStudyImgs.course_g_blue,
          totalColor: 'blue',
          price: 6680,
          SuitableData: [
            { id: 1, content: '基础相对薄弱的新老考生' },
            { id: 2, content: '单科突破，想要定点辅导的考生' },
            { id: 3, content: '没时间备考，但想取得学历的考生' },
          ],
          CourseContentData: [
            {
              id: 1,
              title: '导学',
              list: [{ id: 1, content: '考情考纲详解' }],
            },
            {
              id: 2,
              title: '精讲',
              list: [{ id: 1, content: '基础知识点详解' }],
            },
            {
              id: 3,
              title: '考前冲刺',
              list: [{ id: 1, content: '考前历年真题冲刺讲解（直播）' }],
            },
          ],
          CourseData: [
            { id: 1, content: '考情考纲 —— 官方考纲，梳理课程的重难点脉络' },
            { id: 2, content: '通关宝典 —— 考前资料，浓缩整科知识要点' },
          ],
          studyBankData: [
            { id: 1, title: '章节练习' },
            { id: 2, title: '历年真题' },
            { id: 3, title: '模拟考试' },
            { id: 4, title: '错题集' },
          ],
          studyFormData: [{ id: 1, title: '视频课程+在线直播课程（可回放）' }],
          studyModeData: [
            { id: 1, content: 'PC端+手机端在线学习' },
            { id: 2, content: '系统智能辅导，针对每个考生的薄弱知识点，每日智能推荐学习内容' },
          ],
          serviceData: [
            {
              id: 1,
              url: selfStudyImgs.course_fu_blue,
              list: [
                { id: 1, content: '随堂助教专业答疑' },
                { id: 2, content: '专职学管师课程规划' },
                { id: 3, content: '重要考试提醒服务' },
                { id: 4, content: '报名考试全程指导' },
                { id: 5, content: '人性化课程延时服务' },
                { id: 6, content: '<span style="color: #d18f2d;">学士学位申办指导</span>' },
                { id: 7, content: '<span style="color: #d18f2d;">毕业证申办指导</span>' },
              ],
            },
            {
              id: 2,
              url: selfStudyImgs.course_bz_red,
              list: [{ id: 1, content: '不过退费，若考试不通过，可获得协议赔付' }],
            },
          ],
        },
        {
          id: 3,
          title: '基础套餐班',
          vipImg: '',
          recommendImg: '',
          titleImg: selfStudyImgs.course_class_green,
          subtitleImg: selfStudyImgs.course_g_green,
          totalColor: 'green',
          price: 4680,
          SuitableData: [
            { id: 1, content: '参加过考试，有考试经验的考生' },
            { id: 2, content: '学习自律性强的考生' },
          ],
          CourseContentData: [
            {
              id: 1,
              title: '精讲',
              list: [{ id: 1, content: '基础知识点详解' }],
            },
            {
              id: 2,
              title: '串讲',
              list: [{ id: 1, content: '重要考点串讲解' }],
            },
          ],
          CourseData: [{ id: 1, content: '考情考纲 —— 官方考纲，梳理课程的重难点脉络' }],
          studyBankData: [
            { id: 1, title: '章节练习' },
            { id: 2, title: '历年真题' },
            { id: 3, title: '模拟考试' },
            { id: 4, title: '错题集' },
          ],
          studyFormData: [{ id: 1, title: '视频课程' }],
          studyModeData: [
            { id: 1, content: 'PC端+手机端在线学习' },
            { id: 2, content: '系统智能辅导，针对每个考生的薄弱知识点，每日智能推荐学习内容' },
          ],
          serviceData: [
            {
              id: 1,
              url: selfStudyImgs.course_fu_green,
              list: [
                { id: 1, content: '学员入门导学' },
                { id: 2, content: '学习平台开班指导' },
                { id: 3, content: '随堂助教专业答疑' },
                { id: 4, content: '报名考试流程指导' },
              ],
            },
          ],
        },
      ],
    },
    {
      id: 2,
      title: '专本同读',
      active: false,
      list: [
        {
          id: 1,
          title: '专本尊享班',
          vipImg: selfStudyImgs.course_class_vip,
          recommendImg: selfStudyImgs.course_hot,
          titleImg: selfStudyImgs.course_class_yesllow,
          subtitleImg: selfStudyImgs.course_g_yesllow,
          totalColor: 'yellow',
          price: 15880,
          SuitableData: [
            { id: 1, content: '零基础或新参考生' },
            { id: 2, content: '自制力差需要督促的考生' },
            { id: 3, content: '追求性价比的考生' },
          ],
          CourseContentData: [
            {
              id: 1,
              title: '导学',
              list: [{ id: 1, content: '考情考纲详解' }],
            },
            {
              id: 2,
              title: '精讲',
              list: [{ id: 1, content: '基础知识点详解' }],
            },
            {
              id: 3,
              title: '串讲',
              list: [{ id: 1, content: '重要考点串讲解' }],
            },
            {
              id: 4,
              title: '考前冲刺',
              list: [{ id: 1, content: '考前历年真题冲刺讲解（直播）' }],
            },
          ],
          CourseData: [
            { id: 1, content: '考情考纲 —— 官方考纲，梳理课程的重难点脉络' },
            { id: 2, content: '通关宝典 —— 考前资料，浓缩整科知识要点' },
            { id: 3, content: '高频考点 —— 结合历年真题，提炼高频考核点' },
          ],
          studyBankData: [
            { id: 1, title: '章节练习' },
            { id: 2, title: '历年真题' },
            { id: 3, title: '模拟考试' },
            { id: 4, title: '错题集' },
            { id: 5, title: '高频考点' },
          ],
          studyFormData: [{ id: 1, title: '视频课程+在线直播课程（可回放）' }],
          studyModeData: [
            { id: 1, content: 'PC端+手机端在线学习' },
            { id: 2, content: '系统智能辅导，针对每个考生的薄弱知识点，每日智能推荐学习内容' },
            { id: 3, content: 'PC端+错题强化，针对易题进行专项强化练习' },
          ],
          serviceData: [
            {
              id: 1,
              url: selfStudyImgs.course_fu_yesllow,
              list: [
                { id: 1, content: '论文辅导' },
                { id: 2, content: '学位英语主干高频考点讲解' },
                { id: 3, content: 'VIP学员专属内部讲义' },
                { id: 4, content: '随堂助教专业答疑' },
                { id: 5, content: '专职学管师课程规划' },
                { id: 6, content: '人性化课程延时服务' },
                { id: 7, content: '重要考试提醒服务' },
                { id: 8, content: '报名考试全程指导' },
                { id: 9, content: '全程1对1督学服务' },
                { id: 10, content: '薄弱知识专项指导' },
              ],
            },
            {
              id: 2,
              url: selfStudyImgs.course_bz_red,
              list: [
                { id: 1, content: '100%不过退费:若考试不通过，可获得协议赔付（最大100%额度）' },
                { id: 2, content: '奖学金激励' },
                { id: 3, content: '<span style="color: #f01414;">24小时无理由退换</span>' },
                { id: 3, content: '<span style="color: #f01414;">支持分期付款</span>' },
              ],
            },
          ],
        },
      ],
    },
  ],
};

//自考 - 药学 - 课程体系
export const PharmacyCurriculumData = {
  title: '课程体系',
  subtitle: '完备课程，助力轻松考学历',
  name: 'curriculum',
  backgroundImg: selfStudyImgs.yx_title_class,
  totalbackImg: selfStudyImgs.class_bg,
  width: '545px',
  list: [
    { id: 1, serial: '01', code: '03708', name: '中国近代史纲要', natrue: '公共基础课', correspond: '/', sign: '必考', credit: 2, remark: '/' },
    { id: 2, serial: '02', code: '03709', name: '马克思主义基本原理概论', natrue: '公共基础课', correspond: '/', sign: '必考', credit: 4, remark: '/' },
    { id: 3, serial: '03', code: '01757', name: '药物分析（三）', natrue: '专业核心课', correspond: '/', sign: '必考', credit: 5, remark: '/' },
    { id: 4, serial: '04', code: '01759', name: '药物化学（二）', natrue: '专业核心课', correspond: '/', sign: '必考', credit: 4, remark: '/' },
    { id: 5, serial: '05', code: '01761', name: '药剂学（二）', natrue: '专业核心课', correspond: '/', sign: '必考', credit: 6, remark: '/' },
    { id: 6, serial: '06', code: '02051', name: '物理化学（二）', natrue: '专业核心课', correspond: '/', sign: '必考', credit: 6, remark: '/' },
    { id: 7, serial: '07', code: '05522', name: '有机化学（五）', natrue: '专业核心课', correspond: '/', sign: '必考', credit: 4, remark: '/' },
    { id: 8, serial: '08', code: '06831', name: '药理学（四）', natrue: '专业核心课', correspond: '/', sign: '必考', credit: 5, remark: '/' },
    { id: 9, serial: '09', code: '00015', name: '英语（二）', natrue: '选考课', correspond: '/', sign: '选考', credit: 14, remark: '选考课不得低于5门、学分不得低于28学分', rowspan: 9 },
    { id: 10, serial: '10', code: '00018', name: '计算机应用基础', natrue: '选考课', correspond: '/', sign: '选考', credit: 2, remark: '' },
    { id: 11, serial: '11', code: '02087', name: '分子生物学', natrue: '选考课', correspond: '/', sign: '选考', credit: 6, remark: '' },
    { id: 12, serial: '12', code: '03049', name: '数理统计', natrue: '选考课', correspond: '/', sign: '选考', credit: 4, remark: '' },
    { id: 13, serial: '13', code: '05524', name: '药用植物与生药学', natrue: '选考课', correspond: '/', sign: '选考', credit: 4, remark: '' },
    { id: 14, serial: '14', code: '07781', name: '药事管理学（一）', natrue: '选考课', correspond: '/', sign: '选考', credit: 6, remark: '' },
    { id: 15, serial: '15', code: '07795', name: '药学概论', natrue: '选考课', correspond: '/', sign: '选考', credit: 4, remark: '' },
    { id: 16, serial: '16', code: '09128', name: '临床药物治疗学', natrue: '选考课', correspond: '/', sign: '选考', credit: 6, remark: '' },
    { id: 17, serial: 'S5', code: '00019', name: '计算机应用基础（实践）', natrue: '实践性环节', correspond: '00018-计算机应用基础', sign: '选考', credit: 2, remark: '' },
    { id: 18, serial: '17', code: '10394', name: '药学毕业论文', natrue: '实践性环节', correspond: '/', sign: '必考', credit: 0, remark: ' ' },
    { id: 19, serial: 'S1', code: '01758', name: '药物分析（三）（实践）', natrue: '实践性环节', correspond: '01757-药物分析（三）', sign: '必考', credit: 2, remark: ' ' },
    { id: 20, serial: 'S2', code: '01760', name: '药物分析（二）（实践）', natrue: '实践性环节', correspond: '01759-药物化学（二）', sign: '必考', credit: 1, remark: ' ' },
    { id: 21, serial: 'S3', code: '01762', name: '药理学（二）（实践）', natrue: '实践性环节', correspond: '01761-药剂学（二）', sign: '必考', credit: 2, remark: ' ' },
    { id: 22, serial: 'S4', code: '06832', name: '药理学（二）（实践）', natrue: '实践性环节', correspond: '06831-药理学（四）', sign: '必考', credit: 1, remark: ' ' }
  ]
};



// WEBPACK FOOTER //
// ./src/utils/tools/publicParams.js